import React, { Component } from 'react';
import { normaliseFlightingCode, normaliseFlightingCodeBatch } from '../../utils/flightingCode';
import { useToast } from '../../contexts/ToastContext';
import StarRatingComponent from 'react-star-rating-component';
import AudioFileList from '../AddAudioForm/AudioFileList';
import {
  Button,
  Label,
  FormGroup,
  Form,
  Input,
  Card,
  CardBody,
  Row,
  Col,
  Alert,
} from 'reactstrap';
//import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getRandomColor } from '../../helpers/colors';
import LoaderOverlayContext from '../LoaderOverlay/context';
import ModalConsumer from '../utility/Modal/ModalConsumer';
import { ModalExample, WarningModal } from '../Admin/Users/Users';
import MultiFileUploader from '../../components/utility/FileUploader/MultiFileUploader';
import { doc, collection, getDocs, query, orderBy, onSnapshot, addDoc, deleteDoc } from 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CategorizedAutocomplete from '../CategorizedAutocomplete';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { withStyles } from '@material-ui/core/styles';
// [CHATBOT-DISABLED 2026-09-30] Legacy forked add-track chatbot hidden — see the
// mount below. Import kept commented so the unused-import lint doesn't fail CI builds.
// import AddTrackChatbot from '../Chatbot/AddTrackChatbot';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { useChatbotStore } from '../../store/chatbot.store';
import { useOrganizationStore } from '../../store/organization.store';
import { useCollectionCache } from '../../services/collectionCache.service';
import { getOrgCollectionPath, isOrgScopedCollection } from '../../constants/paths';
// eslint-disable-next-line no-unused-vars
import { generateDomId } from '../../helpers/id';
import { FORM_CONFIG } from '../../config';
import { safeMigration } from '../../config/featureFlags';
import CollapsibleCard from '../CollapsibleCard';
import ComposerChip from '../ComposerChip';
import ShareLicenseModal from '../FindAudio/ShareLicenseModal';

// Static language options for Spot Management
const LANGUAGE_OPTIONS = [
  { label: 'English', value: 'english' },
  { label: 'Afrikaans', value: 'afrikaans' },
  { label: 'Zulu', value: 'zulu' },
  { label: 'Xhosa', value: 'xhosa' },
  { label: 'Sotho', value: 'sotho' },
  { label: 'Tswana', value: 'tswana' },
  { label: 'Pedi', value: 'pedi' },
  { label: 'Venda', value: 'venda' },
  { label: 'Tsonga', value: 'tsonga' },
  { label: 'Swazi', value: 'swazi' },
  { label: 'Ndebele', value: 'ndebele' },
  { label: 'Portuguese', value: 'portuguese' },
  { label: 'French', value: 'french' },
  { label: 'Other', value: 'other' },
];

const INITIAL_STATE = {
  ...FORM_CONFIG.DEFAULTS.AUDIO_FORM,
  // Additional state not in the default form config
  pendingFileDeletions: [],
  availableTags: [],
  availableClients: [],
  tagsInputValue: '',
  clientInputValue: '',
  agencyInputValue: '',
  producerInputValue: '',
  genreInputValue: '',
  keyInputValue: '',
  bpmInputValue: '',
  studioInputValue: '',
  backupLocationInputValue: '',
  artistInputValue: '',
  albumInputValue: '',
  recordLabelInputValue: '',
  publisherInputValue: '',
  availableArtists: [],
  availableAlbums: [],
  availableRecordLabels: [],
  availablePublishers: [],
  isEditMode: false,
  presets: [],
  showPresets: false,
  presetLoading: false,
  showPresetNameModal: false,
  newPresetName: '',
  singleTrackId: '',
  autoAnalyzeAudio: false, // Disabled for Spot Management MVP (was: true)
  useSimplePrompts: false, // Toggle between verbose and simple audio analysis prompts
  isAudioAnalyzing: false, // Track audio analysis state (Phase 1)
  isApplyingAudioDescription: false, // Track metadata application state (Phase 2)
  pendingAudioDescription: null, // Store audio description ready for application
  pendingEssentiaResults: null, // Store Essentia BPM/Key results ready for application
  // Card expanded states (controlled mode for auto-expansion)
  cardExpanded: {
    job: false,
    date: false,
    trackInfo: false,
    composerDetails: false,
    backupLocation: false,
    notes: false,
    rightsIdentifiers: false,
  },
  // License creation prompt state
  showLicensePromptModal: false,
  showCreateLicenseModal: false,
  pendingLicenseTrackData: null,
  pendingLicenseTrackId: null,
  pendingLicenseShouldReset: false,
  // Public catalogue state
  isPublic: false,
  isPublicOriginal: false, // Track original value to detect changes
};

//const wavFilesId = generateDomId();

//const mp3FilesId = generateDomId();

const createFlightingCodeMap = ({ state }) => {
  const { wavFiles, mp3Files } = state;
  return [
    ...wavFiles.map((file) => file.flightingCode),
    ...mp3Files.map((file) => file.flightingCode),
  ];
};

const styles = theme => ({
  autocomplete: {
    width: '100%',
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent',
      color: '#fff',
      minHeight: '32px',
      fontFamily: 'var(--font-family-primary)',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.2) !important',
        borderWidth: '1px'
      },
      '& .MuiAutocomplete-tag': {
        backgroundColor: 'var(--accent-1-color)',
        borderRadius: '8px',
        margin: '2px',
        padding: '4px 8px',
        color: '#fff',
        fontSize: 'var(--menu-font-size)',
        fontFamily: 'var(--font-family-primary)',
        '& .MuiChip-label': {
          padding: '0 4px'
        },
        '& .MuiChip-deleteIcon': {
          color: '#fff',
          fontSize: '16px',
          margin: '0 2px 0 -4px'
        }
      }
    },
    '& input': {
      padding: '4px 8px',
      fontSize: 'var(--menu-font-size)',
      fontFamily: 'var(--font-family-primary)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.1)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.2)'
    },
    '& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator': {
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
      }
    },
    '& .MuiAutocomplete-popper': {
      '& .MuiPaper-root': {
        color: '#fff'
      },
      '& .MuiAutocomplete-option': {
        fontSize: 'var(--menu-font-size)',
        fontFamily: 'var(--font-family-primary)',
        padding: '8px 16px',
        '&[data-focus="true"]': {
          backgroundColor: 'rgba(255, 255, 255, 0.02)'
        },
        '&[aria-selected="true"]': {
          backgroundColor: 'var(--accent-1-color)',
          borderRadius: '8px',
          margin: '2px 8px',
          color: '#fff'
        }
      }
    }
  },
  chip: {
    backgroundColor: 'var(--accent-1-color)',
    color: '#fff',
    margin: theme.spacing(0.25),
    height: '20px',
    fontFamily: 'Poppins, sans-serif',
    '& .MuiChip-label': {
      padding: '0 6px',
      fontSize: '0.75rem',
      fontFamily: 'Poppins, sans-serif'
    },
    '& .MuiChip-deleteIcon': {
      color: '#fff',
      fontSize: '16px',
      margin: '0 2px 0 -4px'
    }
  }
});

// Helper for styled selected value
const renderSelectedValue = (selected, key = 'label') => (selected && selected[key]) ? (
  <span
    style={{
      background: 'var(--accent-1-color)',
      color: '#fff',
      borderRadius: 8,
      padding: '4px 12px',
      fontFamily: 'var(--font-family-primary)',
      fontSize: 'var(--menu-font-size)',
      display: 'inline-block',
      marginRight: 4,
      minWidth: 0,
    }}
  >
    {selected[key]}
  </span>
) : null;

const HYDRATE_FIELDS = [
  { stateKey: 'tags', optionsKey: 'availableTags' },
  { stateKey: 'composer', optionsKey: 'availableComposers' },
  { stateKey: 'sessionArtists', optionsKey: 'availableSessionArtists' },
  { stateKey: 'creativedirector', optionsKey: 'availableCreativeDirectors' },
  { stateKey: 'flightingPlatform', optionsKey: 'availableFlightingPlatforms' },
];

// Helper to robustly hydrate a value array to full option objects
// Preserves additional fields like 'split' for composers
function robustHydrateMultiSelectValue(valueArray, optionsArray) {
  if (!Array.isArray(valueArray)) return [];
  return valueArray.map(item => {
    // Preserve additional fields from the item (like split for composers)
    const additionalFields = {};
    if (item && typeof item === 'object') {
      // Copy over any fields that aren't the standard id/name/label/value
      Object.keys(item).forEach(key => {
        if (!['id', 'name', 'label', 'value'].includes(key)) {
          additionalFields[key] = item[key];
        }
      });
    }

    if (item && (item.name || item.label)) return { ...item };
    if (typeof item === 'string') {
      const found = optionsArray.find(opt => opt.id === item || opt.value === item || opt.label === item || opt.name === item);
      return found ? { ...found, ...additionalFields } : { id: item, name: item, label: item, value: item, ...additionalFields };
    }
    if (item && (item.id || item.value || item.label)) {
      const found = optionsArray.find(opt =>
        (opt.id === item.id || opt.value === item.value || opt.label === item.label || opt.name === item.name)
      );
      return found
        ? { ...found, ...additionalFields }
        : { ...item, name: item.name || item.label || item.value || item.id, label: item.label || item.name || item.value || item.id };
    }
    return item;
  });
}

// Helper to map multi-selects to {label, value} for Firestore
function mapToLabelValue(arr) {
  return Array.isArray(arr)
    ? arr.map(item => ({
        label: item.label || item.name || '',
        value: item.value || item.id || ''
      }))
    : arr;
}

// Helper to map single-selects to {label, value} for Firestore
function mapSingleToLabelValue(obj) {
  if (!obj || typeof obj !== 'object') return { label: '', value: '' };
  return {
    label: obj.label || obj.name || '',
    value: obj.value || obj.id || ''
  };
}

// Add at the top of the file (after imports)
function canCreateOptionForField(fieldName) {
  // TODO: Implement real role/permission logic
  // For now, allow all fields
  return true;
}

// Update makeCreatableFilterOptions to accept fieldName and use canCreateOptionForField
function makeCreatableFilterOptions(options, { inputValue }, fieldName) {
  const filtered = options.filter(option =>
    (option.label || option.name || '').toLowerCase().includes(inputValue.toLowerCase())
  );
  const exists = options.some(option =>
    (option.label || option.name || '').toLowerCase() === inputValue.toLowerCase()
  );
  if (
    inputValue !== '' &&
    !exists &&
    canCreateOptionForField(fieldName)
  ) {
    filtered.push({
      inputValue,
      label: `Create "${inputValue}"`,
      isCreate: true,
    });
  }
  return filtered;
}

// Normalization function to match old track format and remove UI-only fields
function normalizeForSave(state) {
  // List of fields to keep (add/remove as needed)
  const allowedFields = [
    // Active fields for Spot Management MVP
    'mp3Files', 'wavFiles', 'trackName', 'tags', 'language', 'jobTitle', 'jobId', 'jobCampaign',
    'producer', 'agency', 'client', 'creativedirector', 'studio',
    'dateCompleted', 'dateExpires', 'notes', 'audioMetaRef', 'defaultMp3Id',
    'approval_status', 'qc_status', 'is_broadcast_master', 'broadcast_master_file',
    'fileVersion', 'qcVersion', 'fileHistory',
    // Commented out for Spot Management MVP - re-enable as needed
    // 'trackRating', 'trackColor', 'album', 'artist', 'genre', 'bpm', 'key',
    // 'composer', 'sessionArtists', 'flightingPlatform', 'flightingCodes',
    // 'backupLocation', 'isrc', 'iswc', 'recordLabel', 'publisher',
    // 'flightingCode', 'assignedUid'
  ];

  // Helper for single-selects: convert empty object to ""
  function normalizeSingleSelect(val) {
    if (!val || (typeof val === 'object' && (!val.label && !val.value))) return "";
    return mapSingleToLabelValue(val);
  }

  // Helper for multi-selects: ensure array of {label, value}
  function normalizeMultiSelect(val) {
    if (!Array.isArray(val)) return [];
    return mapToLabelValue(val);
  }

  // Helper for composer multi-select: preserve split field along with label/value
  // Auto-fills empty splits with equal distribution at save time
  // Uses single decimal precision with last composer absorbing rounding difference
  function normalizeComposerMultiSelect(val) {
    if (!Array.isArray(val) || val.length === 0) return [];

    // Separate composers with manual splits from those needing auto-calculation
    const manualSplitsTotal = val.reduce((sum, item) => {
      return sum + (item.split !== undefined && item.split !== '' ? Number(item.split) : 0);
    }, 0);
    const composersWithoutSplit = val.filter(item => item.split === undefined || item.split === '');
    const remainingPercent = Math.max(0, 100 - manualSplitsTotal);

    // Calculate base split with single decimal precision
    const baseSplit = composersWithoutSplit.length > 0
      ? Math.floor((remainingPercent / composersWithoutSplit.length) * 10) / 10
      : 0;

    // Calculate what the last composer needs to make it total correctly
    const totalFromBaseSplits = baseSplit * (composersWithoutSplit.length - 1);
    const lastComposerSplit = composersWithoutSplit.length > 0
      ? Math.round((remainingPercent - totalFromBaseSplits) * 10) / 10
      : 0;

    // Track which composers without splits we've processed
    let autoSplitIndex = 0;
    const totalAutoSplits = composersWithoutSplit.length;

    return val.map(item => {
      const hasManualSplit = item.split !== undefined && item.split !== '';
      let split;

      if (hasManualSplit) {
        split = item.split;
      } else {
        autoSplitIndex++;
        // Last auto-split composer gets the adjusted value
        split = autoSplitIndex === totalAutoSplits ? lastComposerSplit : baseSplit;
      }

      return {
        label: item.label || item.name || '',
        value: item.value || item.id || '',
        split: split
      };
    });
  }

  const result = {};
  for (const key of allowedFields) {
    if (key in state) {
      if ([
        'agency', 'client', 'producer', 'studio', 'genre', 'bpm', 'key', 'backupLocation',
        'artist', 'album', 'recordLabel', 'publisher'
      ].includes(key)) {
        result[key] = normalizeSingleSelect(state[key]);
      } else if (key === 'composer') {
        // Special handling for composer to preserve split percentages
        result[key] = normalizeComposerMultiSelect(state[key]);
      } else if ([
        'tags', 'language', 'creativedirector', 'sessionArtists', 'flightingCodes', 'flightingPlatform'
      ].includes(key)) {
        result[key] = normalizeMultiSelect(state[key]);
      } else {
        result[key] = state[key];
      }
    }
  }

  // Spot Management pipeline defaults — set on new uploads, preserved on edits
  if (!result.approval_status) {
    result.approval_status = 'unshared'; // unshared | pending | approved | rejected
  }
  if (!result.qc_status) {
    result.qc_status = 'n/a'; // n/a | pass | fail
  }
  if (result.is_broadcast_master === undefined) {
    result.is_broadcast_master = false;
  }
  if (!result.fileVersion) {
    result.fileVersion = 1;
  }
  if (!result.qcVersion) {
    result.qcVersion = 1; // Starts at 1, file is named _qc1 from first upload
  }
  if (!result.fileHistory) {
    result.fileHistory = [];
  }

  return result;
}

class AddAudioForm extends Component {
  static contextType = LoaderOverlayContext;
  audioMetaRef;

  constructor(props) {
    super(props);
    // Initialize isEditMode based on whether trackId exists
    const isEditMode = !!props.trackId;
    this.state = { 
      ...INITIAL_STATE, 
      isEditMode,
      pendingBatchTracks: [], 
      // Force single mode when editing
      uploadMode: isEditMode ? 'single' : 'single',
      uploaderKey: 0, 
      showSaveToast: false, 
      selectedMp3Id: undefined, 
      // Use trackId if in edit mode, otherwise undefined
      singleTrackId: isEditMode ? props.trackId : undefined,
      tagsInputValue: '', 
      clientInputValue: '', 
      agencyInputValue: '', 
      producerInputValue: '', 
      genreInputValue: '', 
      keyInputValue: '', 
      bpmInputValue: '', 
      studioInputValue: '', 
      backupLocationInputValue: '',
      // Presets state
      presets: [],
      showPresets: false,
      presetLoading: false,
      showPresetNameModal: false,
      newPresetName: '',
    };
    this.uploading = false;
    this.hasQueuedFiles = false;
    this.handleUploaderStatus = this.handleUploaderStatus.bind(this);
    this.hydratedFields = {};
    this.listeners = [];
    this.saveToastTimeout = null;
    this.uploaderFirstPairNameSetter = null;
    // In AddAudioForm class, add a flag to prevent infinite loops
    this.syncingTrackName = false;
    // Add ref for AddTrackChatbot
    this.addTrackChatbotRef = React.createRef();
  }

  isEditing = false;

  selectedFiles = [];

  showLoader(visible) {
    const { setVisible } = this.context;
    setVisible(visible);
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleRatingChange = (value) => {
    this.setState({ trackRating: value });
  };

  handleColorChange = (event) => {
    this.setState({ trackColor: event.hex });
  };

  wavFileUploadedSuccessfully = (fileData) => {
    this.setState({
      wavFiles: [...this.state.wavFiles, { ...fileData }],
    });
  };

  mp3FileUploadedSuccessfully = (fileData) => {
    this.setState({
      mp3Files: [...this.state.mp3Files, { ...fileData }],
    });
  };

  // Helper to remove all available* fields from an object
  removeAvailableFields(obj) {
    const result = { ...obj };
    Object.keys(result).forEach(key => {
      if (key.startsWith('available')) {
        delete result[key];
      }
    });
    return result;
  }

  // Enrich file entries with their byte `size` (read from Storage
  // metadata) for any entry that lacks it. This backfills legacy files
  // uploaded before size was persisted, so simply editing + saving a
  // track populates its storage figure and the dashboard total grows
  // toward accuracy over time. Skipped for referenced copies
  // (isLicensedTrack / delivery copies carry sourceOrgId) whose bytes
  // live in the source org's bucket, and it never overwrites a size
  // that's already present. Failures are swallowed per-file.
  enrichFileSizes = async (orgId, audioMetaData) => {
    if (!orgId || audioMetaData.sourceOrgId) return;
    const trackId = audioMetaData.audioMetaRef;
    if (!trackId) return;
    const enrichGroup = async (group) => {
      const files = audioMetaData[group];
      if (!Array.isArray(files) || files.length === 0) return;
      await Promise.all(files.map(async (f) => {
        if (!f || typeof f.size === 'number' || !f.storageRef) return;
        const size = await this.props.firebase.getOrgFileSize(orgId, trackId, f.storageRef);
        if (typeof size === 'number') f.size = size;
      }));
    };
    await Promise.all([enrichGroup('mp3Files'), enrichGroup('wavFiles')]);
  };

  // Helper to save audio metadata to the correct location (org-scoped or legacy)
  saveAudioMetaData = async (audioMetaData) => {
    const { firebase } = this.props;
    const currentOrgId = useOrganizationStore.getState().currentOrgId;
    const currentOrgName = useOrganizationStore.getState().currentOrgName;

    // Backfill missing file sizes from Storage before persisting so the
    // dashboard storage total reflects this track (see enrichFileSizes).
    await this.enrichFileSizes(currentOrgId, audioMetaData);

    let result;
    if (currentOrgId) {
      // Save to organization-scoped collection
      result = await firebase.saveOrgAudioMetaData(currentOrgId, audioMetaData);
    } else {
      // Fall back to legacy root-level collection
      result = await firebase.saveAudioMetaData(audioMetaData);
    }

    // Handle public catalogue publishing/unpublishing
    if (currentOrgId) {
      const isPublic = this.state.isPublic;
      const wasPublic = this.state.isPublicOriginal;
      const trackId = audioMetaData.audioMetaRef;

      if (isPublic && !wasPublic) {
        // Publishing to public catalogue
        await firebase.publishToMasterCatalogue(currentOrgId, currentOrgName, trackId, audioMetaData);
        console.log('Track published to public catalogue');
      } else if (!isPublic && wasPublic) {
        // Unpublishing from public catalogue
        await firebase.unpublishFromMasterCatalogue(currentOrgId, trackId);
        console.log('Track unpublished from public catalogue');
      } else if (isPublic && wasPublic) {
        // Update existing public catalogue entry
        await firebase.updateMasterCatalogueTrack(currentOrgId, currentOrgName, trackId, audioMetaData);
        console.log('Public catalogue track updated');
      }

      // Update the original state to match current
      this.setState({ isPublicOriginal: isPublic });
    }

    return result;
  }

  // Helper to get the audio meta collection reference (org-scoped or legacy)
  getAudioMetaRef = () => {
    const { firebase } = this.props;
    const currentOrgId = useOrganizationStore.getState().currentOrgId;

    if (currentOrgId) {
      return firebase.getOrgAudioMetaRef(currentOrgId);
    } else {
      return firebase.getAudioMetaRef();
    }
  }

  // Helper to get audio metadata (org-scoped or legacy)
  getAudioMetaData = (trackId) => {
    const { firebase } = this.props;
    const currentOrgId = useOrganizationStore.getState().currentOrgId;

    if (currentOrgId) {
      return firebase.getOrgAudioMetaData(currentOrgId, trackId);
    } else {
      return firebase.getAudioMetaData(trackId);
    }
  }

  // Helper to check if we should prompt for license creation after save
  // Returns true if dateExpires is set and is in the future
  shouldPromptForLicense = (dateExpires) => {
    if (!dateExpires) return false;
    const expiryTimestamp = typeof dateExpires === 'number' ? dateExpires : new Date(dateExpires).getTime();
    return expiryTimestamp > Date.now();
  }

  // Handle the post-save flow - check for license prompt or reset
  handlePostSaveFlow = (trackId, trackData, shouldReset) => {
    const dateExpires = trackData.dateExpires || this.state.dateExpires;

    if (this.shouldPromptForLicense(dateExpires)) {
      // Store track data for potential license creation
      this.setState({
        showLicensePromptModal: true,
        pendingLicenseTrackData: trackData,
        pendingLicenseTrackId: trackId,
        pendingLicenseShouldReset: shouldReset,
      });
    } else if (shouldReset) {
      this.resetTrackData();
    }
  }

  // Handle user accepting license creation prompt
  handleAcceptLicensePrompt = () => {
    this.setState({
      showLicensePromptModal: false,
      showCreateLicenseModal: true,
    });
  }

  // Handle user declining license creation prompt
  handleDeclineLicensePrompt = () => {
    const shouldReset = this.state.pendingLicenseShouldReset;
    this.setState({
      showLicensePromptModal: false,
      pendingLicenseTrackData: null,
      pendingLicenseTrackId: null,
      pendingLicenseShouldReset: false,
    }, () => {
      if (shouldReset) {
        this.resetTrackData();
      }
    });
  }

  // Handle license creation from modal
  handleCreateLicense = async (licenseData) => {
    const { firebase } = this.props;
    const currentOrgId = useOrganizationStore.getState().currentOrgId;
    const trackId = this.state.pendingLicenseTrackId;
    const trackData = this.state.pendingLicenseTrackData;
    const shouldReset = this.state.pendingLicenseShouldReset;

    if (!currentOrgId || !trackId) {
      console.error('Missing org or track ID for license creation');
      return;
    }

    try {
      const { shareTarget, ...licenseFields } = licenseData;

      const fullLicenseData = {
        ...licenseFields,
        createdBy: firebase.auth.currentUser?.uid || '',
        sourceOrgId: currentOrgId,
        // Track metadata snapshots
        key: trackData.key || null,
        bpm: trackData.bpm || null,
        genre: trackData.genre || null,
        tags: trackData.tags || [],
        composer: trackData.composer || [],
        artist: trackData.artist || null,
        album: trackData.album || null,
        recordLabel: trackData.recordLabel || null,
        publisher: trackData.publisher || null,
        sessionArtists: trackData.sessionArtists || [],
        trackColor: trackData.trackColor || null,
      };

      await firebase.createLicense(currentOrgId, trackId, fullLicenseData);

      // Close modal and reset
      this.setState({
        showCreateLicenseModal: false,
        pendingLicenseTrackData: null,
        pendingLicenseTrackId: null,
        pendingLicenseShouldReset: false,
      }, () => {
        if (shouldReset) {
          this.resetTrackData();
        }
      });
    } catch (error) {
      console.error('Error creating license:', error);
    }
  }

  // Handle license modal close without creating
  handleCloseLicenseModal = () => {
    const shouldReset = this.state.pendingLicenseShouldReset;
    this.setState({
      showCreateLicenseModal: false,
      pendingLicenseTrackData: null,
      pendingLicenseTrackId: null,
      pendingLicenseShouldReset: false,
    }, () => {
      if (shouldReset) {
        this.resetTrackData();
      }
    });
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.showLoader(true);

    // Clear pending analysis results when saving
    this.setState({ 
      pendingAudioDescription: null,
      pendingEssentiaResults: null 
    });

    if (this.state.pendingBatchTracks && this.state.pendingBatchTracks.length > 0) {
      // Remove UI-only fields from sharedMeta
      const { selectedMp3Id, pendingFileDeletions, singleTrackId, pendingBatchTracks, uploaderKey, showSaveToast, pendingAudioDescription, pendingEssentiaResults, isAudioAnalyzing, ...sharedMeta } = this.state;
      const { firebase } = this.props;
      const cleanSharedMeta = this.removeAvailableFields(sharedMeta);

      // Derive trackName from each pair's filename, then run the whole batch
      // through the flighting-code normaliser so dashes / slashes / spaces in
      // the upload filenames collapse to underscores. One toast covers the
      // whole batch.
      const rawTrackNames = this.state.pendingBatchTracks.map(pair => pair.mp3?.fileName
        ? pair.mp3.fileName.replace(/\.mp3$/i, '')
        : pair.wav?.fileName
          ? pair.wav.fileName.replace(/\.wav$/i, '')
          : pair.base,
      );
      const { values: normalisedTrackNames, changedCount: batchChangedCount } =
        normaliseFlightingCodeBatch(rawTrackNames);
      if (batchChangedCount > 0 && this.props.showSuccess) {
        this.props.showSuccess(
          `Normalised ${batchChangedCount} flighting code${batchChangedCount === 1 ? '' : 's'} (dashes → underscores)`,
        );
      }

      const savePromises = this.state.pendingBatchTracks.map((pair, idx) => {
        // Use the pre-generated id for this track
        let audioMetaData = {
          ...cleanSharedMeta,
          trackName: normalisedTrackNames[idx],
          mp3Files: pair.mp3 ? [pair.mp3] : [],
          wavFiles: pair.wav ? [pair.wav] : [],
          audioMetaRef: pair.id,
          assignedUid: pair.id, // Set assignedUid to the track's unique ID
        };
        // Normalize before saving
        audioMetaData = normalizeForSave(audioMetaData);
        return safeMigration(
          'useAddAudioForm',
          // Org-aware save method
          async () => this.saveAudioMetaData(audioMetaData),
          // Original method (fallback)
          async () => this.saveAudioMetaData(audioMetaData),
          'AddAudioForm-saveAudioMetaData-batch'
        );
      });
      Promise.all(savePromises)
        .then(() => {
          // After saving, delete pending files
          const batchCurrentOrgId = useOrganizationStore.getState().currentOrgId;
          return Promise.all(
            this.state.pendingFileDeletions.map(filePath => {
              const batchTrackId = this.state.singleTrackId;
              return safeMigration(
                'useAddAudioForm',
                async () => batchCurrentOrgId && batchTrackId
                  ? firebase.deleteOrgFile(batchCurrentOrgId, batchTrackId, filePath)
                  : firebase.deleteFile(filePath),
                async () => batchCurrentOrgId && batchTrackId
                  ? firebase.deleteOrgFile(batchCurrentOrgId, batchTrackId, filePath)
                  : firebase.deleteFile(filePath),
                'AddAudioForm-deleteFile-batch'
              ).catch(() => null);
            })
          );
        })
        .then(async () => {
          this.showLoader(false);
          // Capture batch tracks before clearing state
          const savedBatchTracks = [...(this.state.pendingBatchTracks || [])];
          this.setState({ pendingBatchTracks: [], showSaveToast: true, pendingFileDeletions: [] });
          if (this.saveToastTimeout) clearTimeout(this.saveToastTimeout);
          this.saveToastTimeout = setTimeout(() => this.setState({ showSaveToast: false }), 3000);

          // Auto-publish batch tracks to public catalogue (Master Library)
          try {
            const pubOrgId = useOrganizationStore.getState().currentOrgId;
            const pubOrgName = useOrganizationStore.getState().currentOrgName;
            if (pubOrgId && this.props.firebase) {
              for (const pair of savedBatchTracks) {
                if (pair.id) {
                  const trackData = {
                    ...cleanSharedMeta,
                    // Normalise the same way the primary save did so the
                    // master-catalogue copy stays in sync.
                    trackName: normaliseFlightingCode(
                      pair.mp3?.fileName?.replace(/\.mp3$/i, '') || pair.wav?.fileName?.replace(/\.wav$/i, '') || pair.base,
                    ),
                    mp3Files: pair.mp3 ? [pair.mp3] : [],
                    wavFiles: pair.wav ? [pair.wav] : [],
                  };
                  await this.props.firebase.publishToMasterCatalogue(pubOrgId, pubOrgName || '', pair.id, normalizeForSave(trackData));
                }
              }
            }
          } catch (err) {
            console.error('Error auto-publishing batch to catalogue:', err);
          }

          if (!this.isEditing) {
            this.resetTrackData();
          }
          useChatbotStore.getState().clearChat();
          // Redirect back to job if came from job page
          if (this.props.onSaveComplete) {
            setTimeout(() => this.props.onSaveComplete(), 1000);
          }
        })
        .catch((err) => {
          this.showLoader(false);
        });
    } else {
      // Single mode: save as one track
      let audioMetaRef = this.props.trackId || this.state.singleTrackId || this.state.audioMetaRef;
      if (!audioMetaRef) {
        // New track - use org-scoped collection ref
        audioMetaRef = doc(this.getAudioMetaRef()).id;
        this.setState({ singleTrackId: audioMetaRef });
      }
      // Remove selectedMp3Id, pendingFileDeletions, singleTrackId from saved data
      const { selectedMp3Id, pendingFileDeletions, singleTrackId, pendingBatchTracks, uploaderKey, showSaveToast, pendingAudioDescription, pendingEssentiaResults, isAudioAnalyzing, ...rest } = this.state;
      const cleanRest = this.removeAvailableFields(rest);
      let audioMetaData = {
        ...cleanRest,
        audioMetaRef,
        assignedUid: audioMetaRef, // Set assignedUid to the track's unique ID
        ...(selectedMp3Id ? { defaultMp3Id: selectedMp3Id } : {})
      };
      // Normalize before saving
      audioMetaData = normalizeForSave(audioMetaData);
      safeMigration(
        'useAddAudioForm',
        // Org-aware save method
        async () => this.saveAudioMetaData(audioMetaData),
        // Original method (fallback)
        async () => this.saveAudioMetaData(audioMetaData),
        'AddAudioForm-saveAudioMetaData-single'
      )
        .then(() => {
          // After saving, delete pending files
          const currentOrgId = useOrganizationStore.getState().currentOrgId;
          const trackId = this.props.trackId || this.state.singleTrackId;
          return Promise.all(
            pendingFileDeletions.map(filePath =>
              safeMigration(
                'useAddAudioForm',
                async () => currentOrgId && trackId
                  ? this.props.firebase.deleteOrgFile(currentOrgId, trackId, filePath)
                  : this.props.firebase.deleteFile(filePath),
                async () => currentOrgId && trackId
                  ? this.props.firebase.deleteOrgFile(currentOrgId, trackId, filePath)
                  : this.props.firebase.deleteFile(filePath),
                'AddAudioForm-deleteFile-single'
              ).catch(() => null)
            )
          );
        })
        .then(async () => {
          this.showLoader(false);
          this.setState({ showSaveToast: true, pendingFileDeletions: [] });
          if (this.saveToastTimeout) clearTimeout(this.saveToastTimeout);
          this.saveToastTimeout = setTimeout(() => this.setState({ showSaveToast: false }), 3000);
          useChatbotStore.getState().clearChat();

          // If version changed and track is linked to a job, reset approval/QC status
          // but keep the job link (jobId, jobCampaign, jobTitle) so the track stays associated
          const trackJobId = this.state.jobId;
          if (this.isEditing && trackJobId && this._versionIncrementedForThisEdit) {
            try {
              const currentOrgId = useOrganizationStore.getState().currentOrgId;
              if (currentOrgId) {
                const { doc: fbDoc, updateDoc: fbUpdateDoc } = await import('firebase/firestore');
                const { getOrgCollectionPath } = await import('../../constants/paths');
                // Reset approval and QC status on the track (new version needs re-QC/review)
                const trackRef = fbDoc(this.props.firebase.db, getOrgCollectionPath(currentOrgId, 'audiometa'), audioMetaRef);
                await fbUpdateDoc(trackRef, { approval_status: 'unshared', qc_status: 'n/a' });
              }
            } catch (err) {
              console.error('Error resetting track status after version change:', err);
            }
          }

          // Auto-publish to public catalogue (Master Library)
          try {
            const pubOrgId = useOrganizationStore.getState().currentOrgId;
            const pubOrgName = useOrganizationStore.getState().currentOrgName;
            if (pubOrgId && this.props.firebase) {
              await this.props.firebase.publishToMasterCatalogue(pubOrgId, pubOrgName || '', audioMetaRef, audioMetaData);
            }
          } catch (err) {
            console.error('Error auto-publishing to catalogue:', err);
          }

          // Redirect back to job if came from job page
          if (this.props.onSaveComplete) {
            setTimeout(() => this.props.onSaveComplete(), 1000);
            return;
          }
          // Check if we should prompt for license creation
          const shouldReset = !this.isEditing;
          this.handlePostSaveFlow(audioMetaRef, audioMetaData, shouldReset);
        })
        .catch((err) => {
          this.showLoader(false);
        });
    }
  };

  getTrackData() {
    this.isEditing = true;
    this._versionIncrementedForThisEdit = false;
    this.showLoader(true);
    // Use org-scoped method to load track data
    this.getAudioMetaData(this.props.trackId)
      .then((audioMetaData) => {
        const data = audioMetaData.data();
        let selectedMp3Id = data.defaultMp3Id;
        if (!selectedMp3Id && data.mp3Files && data.mp3Files.length > 0) {
          selectedMp3Id = data.mp3Files[0].storageRef;
        }
        // Robustly hydrate multi-selects if options are already loaded
        const hydrated = { ...data };
        if (this.state.availableTags.length > 0 && Array.isArray(data.tags)) {
          hydrated.tags = robustHydrateMultiSelectValue(data.tags, this.state.availableTags);
        }
        if (this.state.availableComposers && Array.isArray(data.composer)) {
          hydrated.composer = robustHydrateMultiSelectValue(data.composer, this.state.availableComposers);
        }
        if (this.state.availableSessionArtists && Array.isArray(data.sessionArtists)) {
          hydrated.sessionArtists = robustHydrateMultiSelectValue(data.sessionArtists, this.state.availableSessionArtists);
        }
        if (this.state.availableCreativeDirectors && Array.isArray(data.creativedirector)) {
          hydrated.creativedirector = robustHydrateMultiSelectValue(data.creativedirector, this.state.availableCreativeDirectors);
        }
        if (this.state.availableFlightingPlatforms && Array.isArray(data.flightingPlatform)) {
          hydrated.flightingPlatform = robustHydrateMultiSelectValue(data.flightingPlatform, this.state.availableFlightingPlatforms);
        }
        // Load isPublic state for edit mode
        const isPublic = data.isPublic === true;
        this.setState({
          ...hydrated,
          selectedMp3Id,
          singleTrackId: this.props.trackId,
          isPublic,
          isPublicOriginal: isPublic, // Track original value to detect changes
        }, () => {
          // Auto-expand cards that have data in edit mode
          this.expandCardsForEditMode();
        });
        this.audioMetaRef = this.props.trackId;
        this.showLoader(false);
      })
      .catch((err) => {
        this.showLoader(false);
      });
  }

  resetTrackData() {
    this._versionIncrementedForThisEdit = false;
    this.setState(prevState => ({
      ...INITIAL_STATE,
      uploaderKey: prevState.uploaderKey + 1,
      uploadMode: 'single',
      pendingBatchTracks: [],
      pendingFileDeletions: [],
      singleTrackId: prevState.isEditMode ? prevState.singleTrackId : undefined,
      isEditMode: prevState.isEditMode, // preserve edit mode!
      availableTags: prevState.availableTags, // preserve options!
      availableClients: prevState.availableClients,
      availableAgencies: prevState.availableAgencies,
      availableProducers: prevState.availableProducers,
      availableCreativeDirectors: prevState.availableCreativeDirectors,
      availableFlightingPlatforms: prevState.availableFlightingPlatforms,
      availableComposers: prevState.availableComposers,
      availableSessionArtists: prevState.availableSessionArtists,
      availableGenres: prevState.availableGenres,
      availableKeys: prevState.availableKeys,
      availableBpms: prevState.availableBpms,
      availableStudios: prevState.availableStudios,
      availableBackupLocations: prevState.availableBackupLocations,
    }), () => {
      this.audioMetaRef = this.props.firebase.getAudioMetaRef().id;
      this.setState({ trackColor: getRandomColor() });
      this.loadPresets(); // <-- Added to reload presets after reset
    });
  }

  componentDidMount() {
    // Always enforce isEditMode based on trackId
    const shouldBeEditMode = !!this.props.trackId;
    if (this.state.isEditMode !== shouldBeEditMode) {
      this.setState({ isEditMode: shouldBeEditMode });
    }
    if (this.props.trackId) {
      this.getTrackData();
    } else {
      this.resetTrackData();
    }
    this.initOptionListeners();
    this.loadPresets();

    // Subscribe to organization changes to reinitialize listeners
    this.currentOrgId = useOrganizationStore.getState().currentOrgId;
    this.orgUnsubscribe = useOrganizationStore.subscribe((state) => {
      if (state.currentOrgId !== this.currentOrgId) {
        this.currentOrgId = state.currentOrgId;
        // Clear existing listeners
        this.listeners.forEach(unsub => unsub && unsub());
        this.listeners = [];
        // Clear org-scoped available options
        this.setState({
          availableClients: [],
          availableAgencies: [],
          availableProducers: [],
          availableCreativeDirectors: [],
          availableFlightingPlatforms: [],
          availableComposers: [],
          availableSessionArtists: [],
          availableStudios: [],
          availableBackupLocations: [],
        });
        // Reinitialize listeners with new org
        if (state.currentOrgId) {
          this.initOptionListeners();
        }
      }
    });
  }

  componentWillUnmount() {
    // Remove all Firestore listeners
    this.listeners.forEach(unsub => unsub && unsub());
    // Unsubscribe from organization store
    if (this.orgUnsubscribe) {
      this.orgUnsubscribe();
    }
    // Clear toast timeout if it exists
    if (this.saveToastTimeout) {
      clearTimeout(this.saveToastTimeout);
      this.saveToastTimeout = null;
    }
    // Clear pending analysis results to prevent memory leaks
    this.setState({
      pendingAudioDescription: null,
      pendingEssentiaResults: null
    });
  }

  initOptionListeners = () => {
    const { firebase } = this.props;
    const currentOrgId = useOrganizationStore.getState().currentOrgId;

    // Helper to get the correct collection path (org-scoped or global)
    const getCollectionPath = (collectionName) => {
      // Alias: audiometa's Studio picker previously read from the org-
      // scoped /organizations/{orgId}/studio collection, which meant
      // every org had its own private studio list — inconsistent with
      // the campaign modal's Studio picker (which reads /artists-global,
      // the platform-wide studio-org registry). Route audiometa Studio
      // reads to the same global source so both pickers share one
      // canonical list and campaign → audiometa propagation stays
      // consistent.
      if (collectionName === 'studio') {
        return 'artists-global';
      }
      if (isOrgScopedCollection(collectionName) && currentOrgId) {
        return getOrgCollectionPath(currentOrgId, collectionName);
      }
      return collectionName;
    };

    // Helper to set up a listener for a collection
    const listen = (col, stateKey, mapFn) => {
      const collectionPath = getCollectionPath(col);
      const q = query(collection(firebase.db, collectionPath), orderBy('label'));
      const unsub = onSnapshot(q, snapshot => {
        const items = snapshot.docs.map(doc => mapFn(doc));
        // Sort alphabetically by label or name
        items.sort((a, b) => {
          const aLabel = (a.label || a.name || '').toLowerCase();
          const bLabel = (b.label || b.name || '').toLowerCase();
          if (aLabel < bLabel) return -1;
          if (aLabel > bLabel) return 1;
          return 0;
        });
        this.setState({ [stateKey]: items });
      }, (error) => {
        // Handle errors gracefully (e.g., collection doesn't exist yet for new orgs)
        console.warn(`Error listening to ${collectionPath}:`, error.message);
        this.setState({ [stateKey]: [] });
      });
      this.listeners.push(unsub);
    };
    listen('tags', 'availableTags', doc => {
      const data = doc.data();
      return { id: doc.id, name: data.name || data.label, value: data.value, label: data.label };
    });
    listen('client', 'availableClients', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('agency', 'availableAgencies', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('producer', 'availableProducers', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('creativedirector', 'availableCreativeDirectors', doc => {
      const data = doc.data();
      return { id: doc.id, name: data.name || data.label, value: data.value, label: data.label };
    });
    listen('flightingplatform', 'availableFlightingPlatforms', doc => {
      const data = doc.data();
      return { id: doc.id, name: data.name || data.label, value: data.value, label: data.label };
    });
    listen('composers', 'availableComposers', doc => {
      const data = doc.data();
      return { id: doc.id, name: data.name || data.label, value: data.value, label: data.label };
    });
    listen('sessionartists', 'availableSessionArtists', doc => {
      const data = doc.data();
      return { id: doc.id, name: data.name || data.label, value: data.value, label: data.label };
    });
    listen('genres', 'availableGenres', doc => {
      const data = doc.data();
      return {
        id: doc.id,
        label: data.label || data.name || doc.id,
        value: data.value || doc.id
      };
    });
    listen('keys', 'availableKeys', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('bpm', 'availableBpms', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('studio', 'availableStudios', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('backuplocation', 'availableBackupLocations', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('artists', 'availableArtists', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('albums', 'availableAlbums', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('recordlabels', 'availableRecordLabels', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
    listen('publishers', 'availablePublishers', doc => {
      const data = doc.data();
      return { id: doc.id, label: data.label, value: data.value };
    });
  };

  removeFileFromFileList(index, group) {
    let files = this.state[group];
    files.splice(index, 1);
    this.setState({ [group]: [...files] }, () => {
      createFlightingCodeMap({ state: this.state });
    });
  }

  updateFlightingCode = ({ group, index, code }) => {
    this.setState(
      (prevState) => ({
        [group]: prevState[group].map((book, i) => {
          if (i === index) {
            return { ...book, flightingCode: code };
          }
          return book;
        }),
      }),
      () => {
        this.setState({
          flightingCodes: [...createFlightingCodeMap({ state: this.state })],
        });
      }
    );
  };

  handleDeleteFile = (filePath, index, group) => {
    // Remove file from UI and add to pending deletions
    this.removeFileFromFileList(index, group);
    this.setState(prevState => ({
      pendingFileDeletions: [...prevState.pendingFileDeletions, filePath],
    }));
  };

  handleRecallReview = async () => {
    const { firebase } = this.props;
    const currentOrgId = useOrganizationStore.getState().currentOrgId;
    if (!firebase || !currentOrgId || !this.props.trackId) return;

    try {
      await firebase.recallReview(currentOrgId, this.props.trackId);
      this.setState({ approval_status: 'unshared' });
    } catch (error) {
      console.error('Error recalling review:', error);
    }
  };

  toggleFileSelected = (filename, status) => {
    if (status && !this.selectedFiles.includes(filename)) {
      this.selectedFiles.push(filename);
    } else if (!status && this.selectedFiles.includes(filename)) {
      this.selectedFiles.splice(this.selectedFiles.indexOf(filename), 1);
    }
  };

  handleBatchUploadSuccess = (fileData) => {
    if (Array.isArray(fileData)) {
      // Single mode: add all files to the correct arrays
      const mp3Files = fileData.filter(f => f.fileName && f.fileName.toLowerCase().endsWith('.mp3'));
      const wavFiles = fileData.filter(f => f.fileName && f.fileName.toLowerCase().endsWith('.wav'));
      this.setState(prevState => {
        const updates = {
          pendingBatchTracks: [],
        };
        if (prevState.isEditMode && prevState.approval_status === 'rejected') {
          // Rejected by client: keep all versions (new files first, then existing older versions)
          updates.mp3Files = [...mp3Files, ...prevState.mp3Files];
          updates.wavFiles = [...wavFiles, ...prevState.wavFiles];
          updates.approval_status = 'unshared';
          updates.qc_status = 'n/a';
          updates.is_broadcast_master = false;
          updates.broadcast_master_file = null;
          if (mp3Files.length > 0) {
            updates.selectedMp3Id = mp3Files[0].storageRef;
          }
        } else if (prevState.isEditMode && (prevState.qc_status === 'fail' || this._versionIncrementedForThisEdit)) {
          // QC fix (or any version increment): keep all versions, reset QC status, clear broadcast master
          updates.mp3Files = [...mp3Files, ...prevState.mp3Files];
          updates.wavFiles = [...wavFiles, ...prevState.wavFiles];
          updates.qc_status = 'n/a';
          updates.is_broadcast_master = false;
          updates.broadcast_master_file = null;
          if (mp3Files.length > 0) {
            updates.selectedMp3Id = mp3Files[0].storageRef;
          }
        } else if (prevState.isEditMode && prevState.approval_status === 'unshared') {
          // Unshared replacement: replace files, queue old files for deletion from Storage
          // Only delete old files that have a DIFFERENT storageRef from the new ones
          const newStorageRefs = new Set([...mp3Files, ...wavFiles].map(f => f.storageRef));
          const oldFilesToDelete = [...prevState.mp3Files, ...prevState.wavFiles]
            .filter(f => f.storageRef && !newStorageRefs.has(f.storageRef))
            .map(f => f.storageRef);
          if (oldFilesToDelete.length > 0) {
            updates.pendingFileDeletions = [...(prevState.pendingFileDeletions || []), ...oldFilesToDelete];
          }
          updates.mp3Files = mp3Files;
          updates.wavFiles = wavFiles;
          // Reset QC status — new file hasn't been tested
          updates.qc_status = 'n/a';
          updates.is_broadcast_master = false;
          updates.broadcast_master_file = null;
          if (mp3Files.length > 0) {
            updates.selectedMp3Id = mp3Files[0].storageRef;
          }
        } else {
          // New track or other: just the uploaded files
          updates.mp3Files = mp3Files;
          updates.wavFiles = wavFiles;
        }
        return updates;
      });
    } else if (fileData && typeof fileData === 'object' && fileData.id) {
      // Batch mode: update the matching track with uploaded file metadata only
      this.setState(prevState => ({
        pendingBatchTracks: prevState.pendingBatchTracks.map(track =>
          track.id === fileData.id
            ? { ...track, wav: fileData.wav, mp3: fileData.mp3 }
            : track
        ),
      }));
    }
  };

  handleUploaderStatus({ uploading, hasQueuedFiles }) {
    //console.log('Uploader status:', { uploading, hasQueuedFiles });
    this.uploading = uploading;
    this.hasQueuedFiles = hasQueuedFiles;
    this.forceUpdate();
  }

  handleUploadModeChange = (mode) => {
    // Only allow mode change if not in edit mode
    if (!this.state.isEditMode) {
      this.setState(prevState => {
        let newTrackName = prevState.trackName;
        // If switching from batch to single and the field says 'Batch Mode', clear it
        if (mode === 'single' && prevState.trackName === 'Batch Mode') {
          newTrackName = '';
        }
        return { uploadMode: mode, trackName: newTrackName };
      });
    }
  };

  handleAutoAnalyzeToggle = () => {
    this.setState(prevState => ({
      autoAnalyzeAudio: !prevState.autoAnalyzeAudio
    }));
  }

  // Toggle public catalogue visibility
  handlePublicToggle = () => {
    this.setState(prevState => ({
      isPublic: !prevState.isPublic
    }));
  };

  // Toggle a specific card's expanded state
  handleCardToggle = (cardName, expanded) => {
    this.setState(prevState => ({
      cardExpanded: {
        ...prevState.cardExpanded,
        [cardName]: expanded,
      },
    }));
  };

  // Expand cards based on which fields have values
  // Call this after preset load or chatbot metadata application
  expandCardsWithValues = (fieldsWithValues) => {
    // Map fields to their corresponding card
    const fieldToCardMap = {
      // Track Info card
      trackName: 'trackInfo',
      artist: 'trackInfo',
      album: 'trackInfo',
      genre: 'trackInfo',
      tags: 'trackInfo',
      key: 'trackInfo',
      bpm: 'trackInfo',
      // Project card (internally called 'job')
      jobTitle: 'job',
      client: 'job',
      agency: 'job',
      producer: 'job',
      creativedirector: 'job',
      flightingPlatform: 'job',
      // Date card
      dateCompleted: 'date',
      dateExpires: 'date',
      // Composer Details card
      composer: 'composerDetails',
      studio: 'composerDetails',
      sessionArtists: 'composerDetails',
      // Backup Location card
      backupLocation: 'backupLocation',
      // Notes card
      notes: 'notes',
      // Rights & Identifiers card
      isrc: 'rightsIdentifiers',
      iswc: 'rightsIdentifiers',
      recordLabel: 'rightsIdentifiers',
      publisher: 'rightsIdentifiers',
      flightingCode: 'rightsIdentifiers',
      assignedUid: 'rightsIdentifiers',
    };

    // Determine which cards need to be expanded
    const cardsToExpand = new Set();
    fieldsWithValues.forEach(field => {
      const card = fieldToCardMap[field];
      if (card) {
        cardsToExpand.add(card);
      }
    });

    // Update card states
    if (cardsToExpand.size > 0) {
      this.setState(prevState => {
        const newCardExpanded = { ...prevState.cardExpanded };
        cardsToExpand.forEach(card => {
          newCardExpanded[card] = true;
        });
        return { cardExpanded: newCardExpanded };
      });
    }
  };

  // Check if all cards are expanded
  areAllCardsExpanded = () => {
    const { cardExpanded } = this.state;
    return Object.values(cardExpanded).every(expanded => expanded === true);
  };

  // Toggle all cards expanded/collapsed
  toggleAllCards = () => {
    const allExpanded = this.areAllCardsExpanded();
    this.setState({
      cardExpanded: {
        job: !allExpanded,
        date: !allExpanded,
        trackInfo: !allExpanded,
        composerDetails: !allExpanded,
        backupLocation: !allExpanded,
        notes: !allExpanded,
        rightsIdentifiers: !allExpanded,
      },
    });
  };

  // Expand cards based on which fields have data (used in edit mode)
  expandCardsForEditMode = () => {
    const fieldsWithValues = [];
    const state = this.state;

    // Track Info card fields
    if (state.trackName) fieldsWithValues.push('trackName');
    if (state.album) fieldsWithValues.push('album');
    if (state.genre) fieldsWithValues.push('genre');
    if (state.tags && state.tags.length > 0) fieldsWithValues.push('tags');
    if (state.key) fieldsWithValues.push('key');
    if (state.bpm) fieldsWithValues.push('bpm');

    // Project card fields (internally called 'job')
    if (state.jobTitle) fieldsWithValues.push('jobTitle');
    if (state.client) fieldsWithValues.push('client');
    if (state.agency) fieldsWithValues.push('agency');
    if (state.producer) fieldsWithValues.push('producer');
    if (state.creativedirector && state.creativedirector.length > 0) fieldsWithValues.push('creativedirector');
    if (state.flightingPlatform && state.flightingPlatform.length > 0) fieldsWithValues.push('flightingPlatform');

    // Date card fields
    if (state.dateCompleted) fieldsWithValues.push('dateCompleted');
    if (state.dateExpires) fieldsWithValues.push('dateExpires');

    // Composer Details card fields
    if (state.composer && state.composer.length > 0) fieldsWithValues.push('composer');
    if (state.studio) fieldsWithValues.push('studio');
    if (state.sessionArtists && state.sessionArtists.length > 0) fieldsWithValues.push('sessionArtists');

    // Backup Location card
    if (state.backupLocation) fieldsWithValues.push('backupLocation');

    // Notes card
    if (state.notes) fieldsWithValues.push('notes');

    // Rights & Identifiers card
    if (state.isrc) fieldsWithValues.push('isrc');
    if (state.iswc) fieldsWithValues.push('iswc');
    if (state.recordLabel) fieldsWithValues.push('recordLabel');
    if (state.publisher) fieldsWithValues.push('publisher');
    if (state.flightingCode) fieldsWithValues.push('flightingCode');

    this.expandCardsWithValues(fieldsWithValues);
  };

  handlePromptToggle = () => {
    this.setState(prevState => ({
      useSimplePrompts: !prevState.useSimplePrompts
    }));
  };

  // Handle composer split percentage changes
  // Uses composer ID to find and update the right composer, avoiding stale state issues
  handleComposerSplitChange = (composerId, newSplit) => {
    this.setState(prevState => {
      const updatedComposers = [...(prevState.composer || [])];

      // Find composer by ID instead of index
      const composerIndex = updatedComposers.findIndex(c =>
        c.id === composerId || c.value === composerId
      );

      if (composerIndex !== -1) {
        updatedComposers[composerIndex] = {
          ...updatedComposers[composerIndex],
          split: newSplit
        };
      }
      return { composer: updatedComposers };
    });
  };

  // Calculate total composer splits (including placeholder values for validation display)
  // Uses single decimal precision with last composer absorbing rounding difference
  getComposerSplitsTotal = () => {
    const { composer } = this.state;
    if (!composer || composer.length === 0) return 0;

    // Calculate manual splits total and count of composers without splits
    const manualSplitsTotal = composer.reduce((sum, c) => {
      return sum + (c.split !== undefined && c.split !== '' ? Number(c.split) : 0);
    }, 0);
    const composersWithoutSplitCount = composer.filter(c => c.split === undefined || c.split === '').length;

    // Calculate what placeholders would contribute (matching the save logic)
    const remainingPercent = Math.max(0, 100 - manualSplitsTotal);
    const baseSplit = composersWithoutSplitCount > 0
      ? Math.floor((remainingPercent / composersWithoutSplitCount) * 10) / 10
      : 0;
    const totalFromBaseSplits = baseSplit * (composersWithoutSplitCount - 1);
    const lastComposerSplit = composersWithoutSplitCount > 0
      ? Math.round((remainingPercent - totalFromBaseSplits) * 10) / 10
      : 0;

    const placeholdersTotal = composersWithoutSplitCount > 0
      ? totalFromBaseSplits + lastComposerSplit
      : 0;

    // Round to 1 decimal place to avoid floating point issues
    return Math.round((manualSplitsTotal + placeholdersTotal) * 10) / 10;
  };

  handleAudioAnalysisStateChange = (isAnalyzing) => {
    this.setState({ isAudioAnalyzing: isAnalyzing });
  };

  handleAudioDescriptionReady = (description) => {
    this.setState({ pendingAudioDescription: description });
  };

  handleApplyAudioDescription = async () => {
    const { pendingAudioDescription, pendingEssentiaResults } = this.state;
    if (!pendingAudioDescription || !this.addTrackChatbotRef?.current) return;
    
    // Start Phase 2 processing - show spinner, hide Apply button
    this.setState({ isApplyingAudioDescription: true });
    
    try {
      // Apply Gemini analysis results (tags, genre, etc.)
      await this.addTrackChatbotRef.current.applyAudioDescription(pendingAudioDescription);
      
      // Apply Essentia results (BPM and Key) if available
      if (pendingEssentiaResults) {
        this.applyEssentiaResults();
      }
      
      // Clear both pending results after applying
      this.setState({ 
        pendingAudioDescription: null,
        pendingEssentiaResults: null,
        isApplyingAudioDescription: false 
      });
    } catch (error) {
      console.error('Error applying audio analysis results:', error);
      this.setState({ isApplyingAudioDescription: false });
    }
  };

  handleAudioAnalysis = async (trackData) => {
    const { file } = trackData;
    
    
    if (!this.addTrackChatbotRef?.current) {
      console.warn('AddTrackChatbot ref not available for audio analysis');
      return;
    }

    
    // Trigger both audio analyses in parallel
    try {
      // 1. Gemini audio analysis (through chatbot)
      const geminiPromise = this.addTrackChatbotRef.current.handleAudioUpload(file);
      
      // 2. Essentia.js BPM/Key analysis
      const essentiaPromise = this.handleEssentiaAnalysis(file);
      
      // Run both analyses in parallel
      await Promise.all([geminiPromise, essentiaPromise]);
    } catch (error) {
      console.error('Audio analysis error:', error);
    }
  };

  handleEssentiaAnalysis = async (file) => {
    try {
      // Import the service dynamically to avoid issues if worker fails to load
      const { essentiaAnalysisService } = await import('../../services/essentiaAnalysisService');
      
      // Validate file first
      const validation = essentiaAnalysisService.validateAudioFile(file);
      if (!validation.valid) {
        console.warn('⚠️ Essentia.js validation failed:', validation.error);
        return;
      }
      
      // Analyze audio
      const results = await essentiaAnalysisService.analyzeAudio(file);
      
      // Store BPM and Key results for later application
      this.storeEssentiaResults(results);
      
    } catch (error) {
      console.error('❌ Essentia.js analysis failed:', error);
      // Don't throw - let Gemini analysis continue even if Essentia fails
    }
  };

  storeEssentiaResults = (results) => {
    // Store results for later application
    this.setState({
      pendingEssentiaResults: results
    });
  };

  applyEssentiaResults = () => {
    const { pendingEssentiaResults } = this.state;
    if (!pendingEssentiaResults) {
      return;
    }

    const { bpm, key } = pendingEssentiaResults;
    
    // Find matching options in Firebase collections
    const { availableBpms = [], availableKeys = [] } = this.state;
    
    // Find or create BPM option
    let bpmOption = availableBpms.find(b => b.label === bpm || b.name === bpm);
    if (!bpmOption) {
      // Create a new option format that will trigger the "Create" flow if saved
      bpmOption = { label: bpm, name: bpm, value: bpm };
    }
    
    // Find or create Key option
    let keyOption = availableKeys.find(k => k.label === key || k.name === key);
    if (!keyOption) {
      // Create a new option format that will trigger the "Create" flow if saved
      keyOption = { label: key, name: key, value: key };
    }
    
    // Apply to state
    this.setState({
      bpm: bpmOption,
      key: keyOption,
      // Clear input values to ensure clean state
      bpmInputValue: '',
      keyInputValue: ''
    });
  };

  // New: handle batch file selection and generate IDs immediately
  handleBatchFilesSelected = (filePairs) => {
    const { firebase } = this.props;
    this.setState(prevState => {
      // LOGGING: Log incoming filePairs and current pendingBatchTracks
      if (!prevState.pendingBatchTracks || prevState.pendingBatchTracks.length === 0) {
        const batchTracks = filePairs.map(pair => ({
          id: pair.id || doc(firebase.getAudioMetaRef()).id,
          ...pair,
        }));
        // LOGGING: Log updated pendingBatchTracks
        return { pendingBatchTracks: batchTracks };
      }
      // Otherwise, merge by id
      const updatedTracks = filePairs.map(pair => {
        if (pair.id) {
          const match = prevState.pendingBatchTracks.find(track => track.id === pair.id);
          if (match) {
            return { ...match, base: pair.base, wav: pair.wav, mp3: pair.mp3 };
          }
        }
        // New pair, generate id
        return { id: pair.id || doc(firebase.getAudioMetaRef()).id, ...pair };
      });
      // LOGGING: Log updated pendingBatchTracks
      return { pendingBatchTracks: updatedTracks };
    });
  };

  // Update the single file selection handler
  handleSingleFilesSelected = (files) => {
    if (!files || files.length === 0) return;
    if (this.state.isEditMode) {
      if (this.state.approval_status === 'rejected') {
        // Rejected by client: increment review version (creative change), reset QC version
        const currentVersion = this.state.fileVersion || 1;
        if (!this._versionIncrementedForThisEdit) {
          this._versionIncrementedForThisEdit = true;
          this.setState({ fileVersion: currentVersion + 1, qcVersion: 1 });
        }
      } else if (this.state.qc_status === 'fail') {
        // QC fix: increment QC version (mix fix, regardless of approval status)
        const currentQCVersion = this.state.qcVersion || 1;
        if (!this._versionIncrementedForThisEdit) {
          this._versionIncrementedForThisEdit = true;
          this.setState({ qcVersion: currentQCVersion + 1, qc_status: 'n/a' });
        }
      }
    }
    // If not in edit mode and no singleTrackId exists, generate a new one
    if (!this.state.isEditMode && !this.state.singleTrackId) {
      const { firebase } = this.props;
      const newId = doc(firebase.getAudioMetaRef()).id;
      this.setState({ singleTrackId: newId });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Hydrate multi-selects after options or values change, but only once per field
    HYDRATE_FIELDS.forEach(({ stateKey, optionsKey }) => {
      const value = this.state[stateKey];
      const options = this.state[optionsKey];
      if (
        Array.isArray(value) &&
        Array.isArray(options) &&
        value.length > 0 &&
        value.some(v => !(v && (v.name || v.label))) &&
        !this.hydratedFields[stateKey]
      ) {
        const hydrated = value.map(item => {
          if (item && (item.name || item.label)) return item;
          const found = options.find(opt =>
            (item && (opt.id === item.id || opt.value === item.value || opt.label === item.label))
          );
          // Preserve extra fields from the original item (like split for composers)
          if (found && item && typeof item === 'object') {
            const extraFields = {};
            Object.keys(item).forEach(key => {
              if (!['id', 'name', 'label', 'value'].includes(key)) {
                extraFields[key] = item[key];
              }
            });
            return { ...found, ...extraFields };
          }
          return found || item;
        });
        this.hydratedFields[stateKey] = true;
        this.setState({ [stateKey]: hydrated });
      }
    });

    // Hydrate client single-select (make same as other single selectors)
    if (
      this.state.client &&
      this.state.availableClients &&
      this.state.availableClients.length > 0 &&
      (prevState.availableClients !== this.state.availableClients || prevState.client !== this.state.client)
    ) {
      const hydratedClient = this.state.availableClients.find(
        opt => opt.value === this.state.client.value
      );
      if (hydratedClient && hydratedClient !== this.state.client) {
        this.setState({ client: hydratedClient });
      }
    }

    // Hydrate agency single-select
    if (
      this.state.agency &&
      this.state.availableAgencies &&
      this.state.availableAgencies.length > 0 &&
      (prevState.availableAgencies !== this.state.availableAgencies || prevState.agency !== this.state.agency)
    ) {
      const hydratedAgency = this.state.availableAgencies.find(
        opt => opt.value === this.state.agency.value
      );
      if (hydratedAgency && hydratedAgency !== this.state.agency) {
        this.setState({ agency: hydratedAgency });
      }
    }

    // Hydrate producer single-select
    if (
      this.state.producer &&
      this.state.availableProducers &&
      this.state.availableProducers.length > 0 &&
      (prevState.availableProducers !== this.state.availableProducers || prevState.producer !== this.state.producer)
    ) {
      const hydratedProducer = this.state.availableProducers.find(
        opt => opt.value === this.state.producer.value
      );
      if (hydratedProducer && hydratedProducer !== this.state.producer) {
        this.setState({ producer: hydratedProducer });
      }
    }

    // Hydrate genre single-select
    if (
      this.state.genre &&
      this.state.availableGenres &&
      this.state.availableGenres.length > 0 &&
      (prevState.availableGenres !== this.state.availableGenres || prevState.genre !== this.state.genre)
    ) {
      const hydratedGenre = this.state.availableGenres.find(
        opt => opt.value === this.state.genre.value
      );
      if (hydratedGenre && hydratedGenre !== this.state.genre) {
        this.setState({ genre: hydratedGenre });
      }
    }

    // Hydrate key single-select
    if (
      this.state.key &&
      this.state.availableKeys &&
      this.state.availableKeys.length > 0 &&
      (prevState.availableKeys !== this.state.availableKeys || prevState.key !== this.state.key)
    ) {
      const hydratedKey = this.state.availableKeys.find(
        opt => opt.value === this.state.key.value
      );
      if (hydratedKey && hydratedKey !== this.state.key) {
        this.setState({ key: hydratedKey });
      }
    }

    // Hydrate bpm single-select
    if (
      this.state.bpm &&
      this.state.availableBpms &&
      this.state.availableBpms.length > 0 &&
      (prevState.availableBpms !== this.state.availableBpms || prevState.bpm !== this.state.bpm)
    ) {
      const hydratedBpm = this.state.availableBpms.find(
        opt => opt.value === this.state.bpm.value
      );
      if (hydratedBpm && hydratedBpm !== this.state.bpm) {
        this.setState({ bpm: hydratedBpm });
      }
    }

    // Hydrate studio single-select
    if (
      this.state.studio &&
      this.state.availableStudios &&
      this.state.availableStudios.length > 0 &&
      (prevState.availableStudios !== this.state.availableStudios || prevState.studio !== this.state.studio)
    ) {
      const hydratedStudio = this.state.availableStudios.find(
        opt => opt.value === this.state.studio.value
      );
      if (hydratedStudio && hydratedStudio !== this.state.studio) {
        this.setState({ studio: hydratedStudio });
      }
    }

    // Hydrate backupLocation single-select
    if (
      this.state.backupLocation &&
      this.state.availableBackupLocations &&
      this.state.availableBackupLocations.length > 0 &&
      (prevState.availableBackupLocations !== this.state.availableBackupLocations || prevState.backupLocation !== this.state.backupLocation)
    ) {
      const hydratedBackupLocation = this.state.availableBackupLocations.find(
        opt => opt.value === this.state.backupLocation.value
      );
      if (hydratedBackupLocation && hydratedBackupLocation !== this.state.backupLocation) {
        this.setState({ backupLocation: hydratedBackupLocation });
      }
    }

    // Hydrate artist single-select
    if (
      this.state.artist &&
      this.state.availableArtists &&
      this.state.availableArtists.length > 0 &&
      (prevState.availableArtists !== this.state.availableArtists || prevState.artist !== this.state.artist)
    ) {
      const hydratedArtist = this.state.availableArtists.find(
        opt => opt.value === this.state.artist.value
      );
      if (hydratedArtist && hydratedArtist !== this.state.artist) {
        this.setState({ artist: hydratedArtist });
      }
    }

    // Hydrate album single-select
    if (
      this.state.album &&
      this.state.availableAlbums &&
      this.state.availableAlbums.length > 0 &&
      (prevState.availableAlbums !== this.state.availableAlbums || prevState.album !== this.state.album)
    ) {
      const hydratedAlbum = this.state.availableAlbums.find(
        opt => opt.value === this.state.album.value
      );
      if (hydratedAlbum && hydratedAlbum !== this.state.album) {
        this.setState({ album: hydratedAlbum });
      }
    }

    // Hydrate recordLabel single-select
    if (
      this.state.recordLabel &&
      this.state.availableRecordLabels &&
      this.state.availableRecordLabels.length > 0 &&
      (prevState.availableRecordLabels !== this.state.availableRecordLabels || prevState.recordLabel !== this.state.recordLabel)
    ) {
      const hydratedRecordLabel = this.state.availableRecordLabels.find(
        opt => opt.value === this.state.recordLabel.value
      );
      if (hydratedRecordLabel && hydratedRecordLabel !== this.state.recordLabel) {
        this.setState({ recordLabel: hydratedRecordLabel });
      }
    }

    // Hydrate publisher single-select
    if (
      this.state.publisher &&
      this.state.availablePublishers &&
      this.state.availablePublishers.length > 0 &&
      (prevState.availablePublishers !== this.state.availablePublishers || prevState.publisher !== this.state.publisher)
    ) {
      const hydratedPublisher = this.state.availablePublishers.find(
        opt => opt.value === this.state.publisher.value
      );
      if (hydratedPublisher && hydratedPublisher !== this.state.publisher) {
        this.setState({ publisher: hydratedPublisher });
      }
    }

    // Hydrate tags multi-select (make same as other multi selectors)
    if (
      Array.isArray(this.state.tags) &&
      Array.isArray(this.state.availableTags) &&
      this.state.tags.length > 0 &&
      this.state.availableTags.length > 0 &&
      (
        prevState.availableTags !== this.state.availableTags ||
        prevState.tags !== this.state.tags
      )
    ) {
      const hydratedTags = this.state.tags.map(tag =>
        this.state.availableTags.find(opt => opt.value === tag.value) || tag
      );
      const needsUpdate = hydratedTags.some((t, i) => t !== this.state.tags[i]);
      if (needsUpdate) {
        this.setState({ tags: hydratedTags });
      }
    }

    // Hydrate composer multi-select - preserve extra fields like 'split'
    // Only run when availableComposers changes (not when composer changes, to avoid overwriting splits)
    if (
      Array.isArray(this.state.composer) &&
      Array.isArray(this.state.availableComposers) &&
      this.state.composer.length > 0 &&
      this.state.availableComposers.length > 0 &&
      prevState.availableComposers !== this.state.availableComposers
    ) {
      const hydratedComposer = this.state.composer.map(item => {
        const found = this.state.availableComposers.find(opt => opt.value === item.value);
        if (found && !(item.name || item.label)) {
          // Only hydrate if item doesn't already have name/label
          // Preserve extra fields from the original item (like split)
          const extraFields = {};
          if (item && typeof item === 'object') {
            Object.keys(item).forEach(key => {
              if (!['id', 'name', 'label', 'value'].includes(key)) {
                extraFields[key] = item[key];
              }
            });
          }
          return Object.keys(extraFields).length > 0 ? { ...found, ...extraFields } : found;
        }
        return item;
      });
      const needsUpdate = hydratedComposer.some((t, i) => t !== this.state.composer[i]);
      if (needsUpdate) {
        this.setState({ composer: hydratedComposer });
      }
    }

    // Hydrate sessionArtists multi-select
    if (
      Array.isArray(this.state.sessionArtists) &&
      Array.isArray(this.state.availableSessionArtists) &&
      this.state.sessionArtists.length > 0 &&
      this.state.availableSessionArtists.length > 0 &&
      (
        prevState.availableSessionArtists !== this.state.availableSessionArtists ||
        prevState.sessionArtists !== this.state.sessionArtists
      )
    ) {
      const hydratedSessionArtists = this.state.sessionArtists.map(item =>
        this.state.availableSessionArtists.find(opt => opt.value === item.value) || item
      );
      const needsUpdate = hydratedSessionArtists.some((t, i) => t !== this.state.sessionArtists[i]);
      if (needsUpdate) {
        this.setState({ sessionArtists: hydratedSessionArtists });
      }
    }

    // Hydrate creativedirector multi-select
    if (
      Array.isArray(this.state.creativedirector) &&
      Array.isArray(this.state.availableCreativeDirectors) &&
      this.state.creativedirector.length > 0 &&
      this.state.availableCreativeDirectors.length > 0 &&
      (
        prevState.availableCreativeDirectors !== this.state.availableCreativeDirectors ||
        prevState.creativedirector !== this.state.creativedirector
      )
    ) {
      const hydratedCreativeDirectors = this.state.creativedirector.map(item =>
        this.state.availableCreativeDirectors.find(opt => opt.value === item.value) || item
      );
      const needsUpdate = hydratedCreativeDirectors.some((t, i) => t !== this.state.creativedirector[i]);
      if (needsUpdate) {
        this.setState({ creativedirector: hydratedCreativeDirectors });
      }
    }
  }

  // 1. Add a helper for creating new options in Firestore
  createAndSelectOption = async (inputValue, path, stateKey, multi = false, showModal) => {
    if (!canCreateOptionForField(stateKey)) {
      return null;
    }

    const currentOrgId = useOrganizationStore.getState().currentOrgId;
    const collectionPath = isOrgScopedCollection(path) && currentOrgId
      ? getOrgCollectionPath(currentOrgId, path)
      : path;

    // Helper to create the entry and optionally link to an org
    const createEntry = async (linkedOrgId = null) => {
      const { firebase } = this.props;
      const ref = doc(collection(firebase.db, collectionPath));
      const newOption = { label: inputValue, value: ref.id };
      const saveData = linkedOrgId
        ? { ...newOption, linkedOrgId, linkedAt: Date.now() }
        : newOption;
      await firebase.save(saveData, ref.id, collectionPath);
      const optionsKey = `available${stateKey.charAt(0).toUpperCase() + stateKey.slice(1)}`;
      return new Promise((resolve) => {
        this.setState(prevState => {
          const updatedOptions = [
            ...(prevState[optionsKey] || []).filter(opt => opt.value !== newOption.value),
            newOption
          ];
          let updatedValue;
          if (multi) {
            updatedValue = [...(prevState[stateKey] || []).filter(v => v && v.value !== inputValue), newOption];
          } else {
            updatedValue = newOption;
          }
          return {
            [optionsKey]: updatedOptions,
            [stateKey]: updatedValue,
          };
        }, () => resolve(newOption));
      });
    };

    return new Promise((resolve, reject) => {
      if (showModal) {
        // For client/agency fields, check if an org with the same name exists
        const isLinkable = ['client', 'agency'].includes(stateKey);

        // For client/agency, check for matching org and auto-link
        const handleConfirmedCreate = async () => {
          try {
            let linkedOrgId = null;

            if (isLinkable) {
              const { firebase } = this.props;
              const orgsSnapshot = await getDocs(collection(firebase.db, 'organizations'));
              const matchingOrg = orgsSnapshot.docs.find(d =>
                (d.data().name || '').toLowerCase() === inputValue.toLowerCase()
              );
              if (matchingOrg) {
                linkedOrgId = matchingOrg.id;
              }
            }

            const result = await createEntry(linkedOrgId);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        };

        showModal(ModalExample, {
          isOpen: true,
          title: `Create new ${stateKey.charAt(0).toUpperCase() + stateKey.slice(1)}`,
          body: isLinkable
            ? `Create a new ${stateKey} named "${inputValue}"? If an organization with this name exists, it will be automatically linked for direct sharing.`
            : `Are you sure you want to create a new ${stateKey} named "${inputValue}"?`,
          callback: handleConfirmedCreate,
        });
      } else {
        // fallback: no modal, just create
        (async () => {
          try {
            const { firebase } = this.props;
            const ref = doc(collection(firebase.db, collectionPath));
            const newOption = { label: inputValue, value: ref.id };
            await firebase.save(newOption, ref.id, collectionPath);
            const optionsKey = `available${stateKey.charAt(0).toUpperCase() + stateKey.slice(1)}`;
            this.setState(prevState => {
              const updatedOptions = [
                ...(prevState[optionsKey] || []).filter(opt => opt.value !== newOption.value),
                newOption
              ];
              let updatedValue;
              if (multi) {
                updatedValue = [...(prevState[stateKey] || []).filter(v => v && v.value !== inputValue), newOption];
              } else {
                updatedValue = newOption;
              }
              return {
                [optionsKey]: updatedOptions,
                [stateKey]: updatedValue,
              };
            }, () => resolve(newOption));
          } catch (err) {
            reject(err);
          }
        })();
      }
    });
  };

  handleApplyMetadata = (metadata) => {
    // Helper to map array of values to option objects
    const mapToOptions = (arr, available) =>
      (Array.isArray(arr) ? arr.map(val => available.find(opt => opt.label === val || opt.name === val || opt.value === val) || { label: val, name: val, value: val }) : []);
    // Map all single and multi selector fields to option objects
    const {
      availableGenres = [], availableTags = [], availableClients = [], availableAgencies = [], availableProducers = [],
      availableKeys = [], availableBpms = [], availableStudios = [], availableBackupLocations = [],
      availableCreativeDirectors = [], availableFlightingPlatforms = [], availableComposers = [], availableSessionArtists = []
    } = this.state;
    // Support Gemini output: genres (array), composers (array), sessionartists (array)
    // Use first genre for single selector, all composers/sessionartists for multi
    const genreValue = Array.isArray(metadata.genres) && metadata.genres.length > 0
      ? metadata.genres[0]
      : metadata.genre;
    const composerValue = Array.isArray(metadata.composers) && metadata.composers.length > 0
      ? metadata.composers
      : metadata.composer;
    const sessionArtistsValue = Array.isArray(metadata.sessionartists) && metadata.sessionartists.length > 0
      ? metadata.sessionartists
      : metadata.sessionartists;
    // Single-selects
    const genreObj = metadata.hasOwnProperty('genre')
      ? (genreValue
          ? availableGenres.find(g => g.label === genreValue || g.name === genreValue || g.value === genreValue)
            || { label: genreValue, name: genreValue, value: genreValue }
          : null)
      : this.state.genre;
    const clientObj = metadata.hasOwnProperty('client')
      ? (metadata.client
          ? availableClients.find(c => c.label === metadata.client || c.name === metadata.client || c.value === metadata.client)
          : null)
      : this.state.client;
    const agencyObj = metadata.hasOwnProperty('agency')
      ? (metadata.agency
          ? availableAgencies.find(a => a.label === metadata.agency || a.name === metadata.agency || a.value === metadata.agency)
          : null)
      : this.state.agency;
    const producerObj = metadata.hasOwnProperty('producer')
      ? (metadata.producer
          ? availableProducers.find(p => p.label === metadata.producer || p.name === metadata.producer || p.value === metadata.producer)
          : null)
      : this.state.producer;
    const keyObj = metadata.hasOwnProperty('key')
      ? (metadata.key
          ? availableKeys.find(k => k.label === metadata.key || k.name === metadata.key || k.value === metadata.key)
          : null)
      : this.state.key;
    const bpmObj = metadata.hasOwnProperty('bpm')
      ? (metadata.bpm
          ? availableBpms.find(b => b.label === metadata.bpm || b.name === metadata.bpm || b.value === metadata.bpm)
          : null)
      : this.state.bpm;
    const studioObj = metadata.hasOwnProperty('studio')
      ? (metadata.studio
          ? availableStudios.find(s => s.label === metadata.studio || s.name === metadata.studio || s.value === metadata.studio)
          : null)
      : this.state.studio;
    const backupLocationObj = metadata.hasOwnProperty('backuplocation')
      ? (metadata.backuplocation
          ? availableBackupLocations.find(b => b.label === metadata.backuplocation || b.name === metadata.backuplocation || b.value === metadata.backuplocation)
          : null)
      : this.state.backupLocation;
    // Multi-selects: clear if incoming value is [], "", or null; otherwise set to mapped array
    const tagObjs = metadata.hasOwnProperty('tags')
      ? (
          Array.isArray(metadata.tags)
            ? metadata.tags.length === 0
              ? []
              : mapToOptions(metadata.tags, availableTags)
            : (metadata.tags === "" || metadata.tags == null)
              ? []
              : this.state.tags
        )
      : this.state.tags;
    const creativedirectorObjs = metadata.hasOwnProperty('creativedirector')
      ? (
          Array.isArray(metadata.creativedirector)
            ? metadata.creativedirector.length === 0
              ? []
              : mapToOptions(metadata.creativedirector, availableCreativeDirectors)
            : (metadata.creativedirector === "" || metadata.creativedirector == null)
              ? []
              : this.state.creativedirector
        )
      : this.state.creativedirector;
    const flightingPlatformObjs = metadata.hasOwnProperty('flightingplatform')
      ? (
          Array.isArray(metadata.flightingplatform)
            ? metadata.flightingplatform.length === 0
              ? []
              : mapToOptions(metadata.flightingplatform, availableFlightingPlatforms)
            : (metadata.flightingplatform === "" || metadata.flightingplatform == null)
              ? []
              : this.state.flightingPlatform
        )
      : this.state.flightingPlatform;
    const composerObjs = (metadata.hasOwnProperty('composers') || metadata.hasOwnProperty('composer'))
      ? (
          Array.isArray(composerValue)
            ? composerValue.length === 0
              ? []
              : mapToOptions(composerValue, availableComposers)
            : (composerValue === "" || composerValue == null)
              ? []
              : this.state.composer
        )
      : this.state.composer;
    // Only one assignment for sessionArtistObjs with the new clearing logic
    const sessionArtistObjs = metadata.hasOwnProperty('sessionartists')
      ? (
          Array.isArray(sessionArtistsValue)
            ? sessionArtistsValue.length === 0
              ? []
              : mapToOptions(sessionArtistsValue, availableSessionArtists)
            : (sessionArtistsValue === "" || sessionArtistsValue == null)
              ? []
              : this.state.sessionArtists
        )
      : this.state.sessionArtists;
    // Dates
    const dateCompleted = metadata.hasOwnProperty('datecompleted')
      ? (metadata.datecompleted || null)
      : this.state.dateCompleted;
    const dateExpires = metadata.hasOwnProperty('dateexpires')
      ? (metadata.dateexpires || null)
      : this.state.dateExpires;
    // Track Name
    const trackName = metadata.hasOwnProperty('trackname')
      ? metadata.trackname
      : this.state.trackName;
    // Job Title
    const jobTitle = metadata.hasOwnProperty('jobtitle')
      ? metadata.jobtitle
      : this.state.jobTitle;
    this.setState({
      genre: genreObj,
      tags: tagObjs,
      client: clientObj,
      agency: agencyObj,
      producer: producerObj,
      key: keyObj,
      bpm: bpmObj,
      studio: studioObj,
      backupLocation: backupLocationObj,
      creativedirector: creativedirectorObjs,
      flightingPlatform: flightingPlatformObjs,
      composer: composerObjs,
      sessionArtists: sessionArtistObjs,
      trackName,
      jobTitle,
      dateCompleted,
      dateExpires,
    }, () => {
      // Auto-expand cards that received values
      const fieldsWithValues = [];
      if (genreObj) fieldsWithValues.push('genre');
      if (tagObjs && tagObjs.length > 0) fieldsWithValues.push('tags');
      if (keyObj) fieldsWithValues.push('key');
      if (bpmObj) fieldsWithValues.push('bpm');
      if (clientObj) fieldsWithValues.push('client');
      if (agencyObj) fieldsWithValues.push('agency');
      if (producerObj) fieldsWithValues.push('producer');
      if (creativedirectorObjs && creativedirectorObjs.length > 0) fieldsWithValues.push('creativedirector');
      if (flightingPlatformObjs && flightingPlatformObjs.length > 0) fieldsWithValues.push('flightingPlatform');
      if (composerObjs && composerObjs.length > 0) fieldsWithValues.push('composer');
      if (studioObj) fieldsWithValues.push('studio');
      if (sessionArtistObjs && sessionArtistObjs.length > 0) fieldsWithValues.push('sessionArtists');
      if (backupLocationObj) fieldsWithValues.push('backupLocation');
      if (trackName) fieldsWithValues.push('trackName');
      if (jobTitle) fieldsWithValues.push('jobTitle');
      if (dateCompleted) fieldsWithValues.push('dateCompleted');
      if (dateExpires) fieldsWithValues.push('dateExpires');

      this.expandCardsWithValues(fieldsWithValues);
    });
  };

  // Add this handler to update Track Name from uploader
  handleSingleTrackNameEdit = (name) => {
    // Only sync if in single mode and not already syncing
    if (this.state.uploadMode === 'single' && !this.syncingTrackName) {
      this.syncingTrackName = true;
      this.setState({ trackName: name }, () => {
        this.syncingTrackName = false;
      });
    } else {
      this.setState({ trackName: name });
    }
  }

  // Handler to apply chatbot trackname to first pair in queue
  handleApplyTrackNameToFirstPair = (name) => {
    if (!name) return;
    // Batch mode: update first pair in pendingBatchTracks
    if (this.state.uploadMode === 'batch' && this.state.pendingBatchTracks.length > 0) {
      const updated = this.state.pendingBatchTracks.map((pair, idx) => idx === 0 ? { ...pair, base: name } : pair);
      this.setState({ pendingBatchTracks: updated });
    }
    // Single mode: update the 'Full Track' pair in uploader via ref
    if (this.state.uploadMode === 'single' && this.uploaderFirstPairNameSetter) {
      this.uploaderFirstPairNameSetter(name);
      // Also update the Track Name field in the form and expand the Job card
      this.setState({ trackName: name }, () => {
        this.expandCardsWithValues(['trackName']);
      });
    }
  }

  setUploaderFirstPairNameSetter = (setter) => {
    this.uploaderFirstPairNameSetter = setter;
  }

  // Add the setter for batch name application
  setUploaderBatchNameSetter = (setter) => {
    // LOGGING: Log when the setter is set and the function reference
    this.uploaderBatchNameSetter = setter;
  };

  // --- PRESETS LOGIC ---
  authUser = null;
  loadPresets = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      console.error('No authenticated user found when loading presets.');
      return;
    }
    const db = getFirestore();
    this.setState({ presetLoading: true });
    const presetsRef = collection(db, 'users', user.uid, 'presets');
    const snapshot = await getDocs(presetsRef);
    const presets = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    this.setState({ presets, presetLoading: false });
  };
  getAuthUser = () => {
    if (this.authUser) return this.authUser;
    if (this.context && this.context.authUser) {
      this.authUser = this.context.authUser;
      return this.authUser;
    }
    if (this.props.authUser) {
      this.authUser = this.props.authUser;
      return this.authUser;
    }
    // Try AuthUserContext (React context)
    if (window.AuthUserContext && window.AuthUserContext.current) {
      this.authUser = window.AuthUserContext.current;
      return this.authUser;
    }
    return null;
  };
  handleSavePreset = () => {
    this.setState({ showPresetNameModal: true, newPresetName: '' });
  };
  handleConfirmSavePreset = async () => {
    const name = this.state.newPresetName.trim();
    if (!name) return;
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      console.error('No authenticated user found when saving preset.');
      return;
    }
    const db = getFirestore();
    const presetsRef = collection(db, 'users', user.uid, 'presets');
    const presetData = {
      name,
      metadata: this.getCurrentMetadataForPreset(),
      createdAt: new Date().toISOString(),
    };
    try {
      await addDoc(presetsRef, presetData);
      this.setState({ showPresetNameModal: false, newPresetName: '' });
      this.loadPresets();
    } catch (err) {
      console.error('Error saving preset:', err);
    }
  };
  handleApplyPreset = (metadata) => {
    // Get collection cache for validation
    const collectionCache = useCollectionCache.getState();

    // Map preset field names to collection cache keys
    const fieldToCollectionMap = {
      client: 'client',
      agency: 'agency',
      producer: 'producer',
      studio: 'studio',
      backupLocation: 'backuplocation',
      genre: 'genres',
      bpm: 'bpm',
      key: 'keys',
      tags: 'tags',
      composer: 'composers',
      creativedirector: 'creativedirector',
      sessionArtists: 'sessionartists',
      flightingPlatform: 'flightingplatform',
      // Note: artist, album, recordLabel, publisher are not in global collection cache
      // They are org-scoped and loaded directly by AddAudioForm, so we skip cache validation
      // and rely solely on local state options (availableArtists, etc.)
    };

    // Helper to check if a value exists in a collection (checks both collectionCache and local state options)
    const valueExistsInCollection = (value, collectionKey, localOptions = []) => {
      const collectionData = collectionCache[collectionKey] || [];
      if (!value) return false;
      const valStr = typeof value === 'object' ? (value.label || value.name || value.value) : value;

      // Check collection cache first
      const existsInCache = collectionData.some(item =>
        item.displayName === valStr ||
        item.name === valStr ||
        item.label === valStr
      );
      if (existsInCache) return true;

      // Also check local state options (includes newly created items)
      const existsInLocal = localOptions.some(item =>
        item.displayName === valStr ||
        item.name === valStr ||
        item.label === valStr ||
        item.value === valStr
      );
      return existsInLocal;
    };

    // Track skipped values for user feedback
    const skippedValues = [];

    // Map preset field names to local state option keys
    const fieldToLocalOptionsMap = {
      client: 'availableClients',
      agency: 'availableAgencies',
      producer: 'availableProducers',
      studio: 'availableStudios',
      backupLocation: 'availableBackupLocations',
      genre: 'availableGenres',
      bpm: 'availableBpms',
      key: 'availableKeys',
      tags: 'availableTags',
      composer: 'availableComposers',
      creativedirector: 'availableCreativeDirectors',
      sessionArtists: 'availableSessionArtists',
      flightingPlatform: 'availableFlightingPlatforms',
      // New fields
      artist: 'availableArtists',
      album: 'availableAlbums',
      recordLabel: 'availableRecordLabels',
      publisher: 'availablePublishers',
    };

    this.setState(prevState => {
      const merged = { ...prevState };
      const singleSelectors = ['client', 'agency', 'producer', 'studio', 'backupLocation', 'genre', 'bpm', 'key', 'album', 'recordLabel', 'publisher', 'artist'];
      const multiSelectors = ['tags', 'language', 'composer', 'creativedirector', 'sessionArtists', 'flightingPlatform'];

      Object.keys(metadata).forEach(key => {
        const collectionKey = fieldToCollectionMap[key];
        const localOptionsKey = fieldToLocalOptionsMap[key];
        const localOptions = prevState[localOptionsKey] || [];

        // Multi selectors: merge arrays, deduplicate by value, validate against collection
        if (multiSelectors.includes(key) && Array.isArray(metadata[key])) {
          // Use the mapped localOptionsKey, or LANGUAGE_OPTIONS for language field
          const options = key === 'language' ? LANGUAGE_OPTIONS : (prevState[localOptionsKey] || []);
          const current = Array.isArray(prevState[key]) ? prevState[key] : [];

          // Filter and hydrate preset values - only include values that exist in the collection
          const hydratedPreset = [];
          metadata[key].forEach(val => {
            const valStr = typeof val === 'object' ? (val.label || val.name || val.value) : val;

            // Check if value exists in collection cache or local state options
            if (collectionKey && !valueExistsInCollection(valStr, collectionKey, localOptions)) {
              skippedValues.push({ field: key, value: valStr });
              return; // Skip this value
            }

            if (typeof val === 'object' && val.label && val.value) {
              hydratedPreset.push(val);
            } else {
              const found = options.find(opt => opt.label === val || opt.name === val || opt.value === val);
              hydratedPreset.push(found || { label: val, value: val });
            }
          });

          // Merge and deduplicate by value
          const all = [...current, ...hydratedPreset];
          const deduped = [];
          const seen = new Set();
          for (const item of all) {
            const v = item.value || item.label || item.name;
            if (!seen.has(v)) {
              seen.add(v);
              deduped.push(item);
            }
          }
          merged[key] = deduped;
        }
        // Single selectors: validate against collection before applying
        else if (singleSelectors.includes(key)) {
          // Use the mapped localOptionsKey instead of constructing dynamically
          const options = prevState[localOptionsKey] || [];
          const val = metadata[key];
          const valStr = typeof val === 'object' ? (val.label || val.name || val.value) : val;

          // Check if value exists in collection cache or local state options
          if (collectionKey && valStr && !valueExistsInCollection(valStr, collectionKey, localOptions)) {
            skippedValues.push({ field: key, value: valStr });
            // Keep current value, don't apply preset value
          } else if (typeof val === 'object' && val.label && val.value) {
            merged[key] = val;
          } else if (val) {
            const found = options.find(opt => opt.label === val || opt.name === val || opt.value === val);
            merged[key] = found || { label: val, value: val };
          }
        }
        // Only overwrite trackName if preset has a non-empty value
        else if (key === 'trackName') {
          if (metadata.trackName && metadata.trackName.trim()) {
            merged.trackName = metadata.trackName;
          } // else, keep current value
        }
        // Only overwrite jobTitle if preset has a non-empty value
        else if (key === 'jobTitle') {
          if (metadata.jobTitle && metadata.jobTitle.trim()) {
            merged.jobTitle = metadata.jobTitle;
          } // else, keep current value
        }
        // Primitives: preset always overrides
        else if (typeof metadata[key] !== 'object') {
          merged[key] = metadata[key];
        }
        // If object, override
        else if (typeof metadata[key] === 'object' && metadata[key] !== null) {
          merged[key] = metadata[key];
        }
        // Otherwise, keep current value
      });
      merged.showPresets = false;
      // Always preserve the current uploadMode when loading a preset
      merged.uploadMode = prevState.uploadMode;

      return merged;
    }, () => {
      // Auto-expand cards that received values from the preset
      const fieldsWithValues = [];
      const currentState = this.state;

      // Check which fields now have values
      if (currentState.trackName) fieldsWithValues.push('trackName');
      if (currentState.jobTitle) fieldsWithValues.push('jobTitle');
      if (currentState.client) fieldsWithValues.push('client');
      if (currentState.agency) fieldsWithValues.push('agency');
      if (currentState.producer) fieldsWithValues.push('producer');
      if (currentState.creativedirector && currentState.creativedirector.length > 0) fieldsWithValues.push('creativedirector');
      if (currentState.flightingPlatform && currentState.flightingPlatform.length > 0) fieldsWithValues.push('flightingPlatform');
      if (currentState.dateCompleted) fieldsWithValues.push('dateCompleted');
      if (currentState.dateExpires) fieldsWithValues.push('dateExpires');
      if (currentState.genre) fieldsWithValues.push('genre');
      if (currentState.tags && currentState.tags.length > 0) fieldsWithValues.push('tags');
      if (currentState.key) fieldsWithValues.push('key');
      if (currentState.bpm) fieldsWithValues.push('bpm');
      if (currentState.composer && currentState.composer.length > 0) fieldsWithValues.push('composer');
      if (currentState.studio) fieldsWithValues.push('studio');
      if (currentState.sessionArtists && currentState.sessionArtists.length > 0) fieldsWithValues.push('sessionArtists');
      if (currentState.backupLocation) fieldsWithValues.push('backupLocation');
      if (currentState.notes) fieldsWithValues.push('notes');
      // New fields - Track Info
      if (currentState.artist) fieldsWithValues.push('artist');
      if (currentState.album) fieldsWithValues.push('album');
      // Rights & Identifiers fields
      if (currentState.isrc) fieldsWithValues.push('isrc');
      if (currentState.iswc) fieldsWithValues.push('iswc');
      if (currentState.recordLabel) fieldsWithValues.push('recordLabel');
      if (currentState.publisher) fieldsWithValues.push('publisher');
      if (currentState.flightingCode) fieldsWithValues.push('flightingCode');

      this.expandCardsWithValues(fieldsWithValues);

      // After state update, show modal if there were skipped values
      if (skippedValues.length > 0 && this.showModalRef) {
        this.showModalRef(WarningModal, {
          title: 'Some Preset Values Skipped',
          body: (
            <div>
              <p>The following values were skipped because they don't exist in this organization:</p>
              <ul style={{ marginBottom: 0, paddingLeft: '1.25rem' }}>
                {skippedValues.map((item, idx) => (
                  <li key={idx}><strong>{item.field}:</strong> {item.value}</li>
                ))}
              </ul>
            </div>
          ),
          isOpen: true,
          callback: () => {},
        });
      }
    });
  };
  // Toggle for including dates in presets - set to false by default
  // Can be exposed as a UI toggle in future if needed
  INCLUDE_DATES_IN_PRESETS = false;

  getCurrentMetadataForPreset = () => {
    // Use the same logic as currentMetadata in render
    const {
      uploadMode, trackName, tags, language, jobTitle, producer, agency, client, creativedirector, dateCompleted, dateExpires, flightingPlatform, genre, bpm, key, composer, studio, backupLocation, sessionArtists, notes,
      artist, album, recordLabel, publisher
    } = this.state;

    const metadata = {
      uploadMode,
      // trackName excluded from presets — unique per spot
      tags: Array.isArray(tags) ? tags.map(t => t.label || t.name || t.value) : [],
      language: Array.isArray(language) ? language.map(l => l.label || l.name || l.value) : [],
      jobTitle: jobTitle || '',
      producer: producer && (producer.label || producer.name || producer.value) ? (producer.label || producer.name || producer.value) : '',
      agency: agency && (agency.label || agency.name || agency.value) ? (agency.label || agency.name || agency.value) : '',
      client: client && (client.label || client.name || client.value) ? (client.label || client.name || client.value) : '',
      creativedirector: Array.isArray(creativedirector) ? creativedirector.map(cd => cd.label || cd.name || cd.value) : [],
      flightingPlatform: Array.isArray(flightingPlatform) ? flightingPlatform.map(fp => fp.label || fp.name || fp.value) : [],
      genre: genre && (genre.label || genre.name || genre.value) ? (genre.label || genre.name || genre.value) : '',
      bpm: bpm && (bpm.label || bpm.name || bpm.value) ? (bpm.label || bpm.name || bpm.value) : '',
      key: key && (key.label || key.name || key.value) ? (key.label || key.name || key.value) : '',
      composer: Array.isArray(composer) ? composer.map(c => c.label || c.name || c.value) : [],
      studio: studio && (studio.label || studio.name || studio.value) ? (studio.label || studio.name || studio.value) : '',
      backupLocation: backupLocation && (backupLocation.label || backupLocation.name || backupLocation.value) ? (backupLocation.label || backupLocation.name || backupLocation.value) : '',
      sessionArtists: Array.isArray(sessionArtists) ? sessionArtists.map(sa => sa.label || sa.name || sa.value) : [],
      notes: notes || '',
      // New fields - artist is a single select like album
      artist: artist && (artist.label || artist.name || artist.value) ? (artist.label || artist.name || artist.value) : '',
      album: album && (album.label || album.name || album.value) ? (album.label || album.name || album.value) : '',
      recordLabel: recordLabel && (recordLabel.label || recordLabel.name || recordLabel.value) ? (recordLabel.label || recordLabel.name || recordLabel.value) : '',
      publisher: publisher && (publisher.label || publisher.name || publisher.value) ? (publisher.label || publisher.name || publisher.value) : '',
    };

    // Only include dates if the toggle is enabled
    if (this.INCLUDE_DATES_IN_PRESETS) {
      metadata.dateCompleted = dateCompleted;
      metadata.dateExpires = dateExpires;
    }

    return metadata;
  };
  handleDeletePreset = async (presetId) => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      console.error('No authenticated user found when deleting preset.');
      return;
    }
    const db = getFirestore();
    const presetDocRef = doc(db, 'users', user.uid, 'presets', presetId);
    try {
      await deleteDoc(presetDocRef);
      this.loadPresets();
    } catch (err) {
      console.error('Error deleting preset:', err);
    }
  };

  render() {
    let {
      trackRating,
      mp3Files = [],
      wavFiles = [],
      trackName,
      album,
      artist,
      tags,
      language,
      jobTitle,
      producer,
      agency,
      client,
      creativedirector,
      dateCompleted,
      dateExpires,
      flightingPlatform,
      genre,
      bpm,
      key,
      composer,
      studio,
      backupLocation,
      sessionArtists,
      notes,
      uploadMode,
      selectedMp3Id,
      availableTags,
      availableClients,
      isEditMode,
      autoAnalyzeAudio,
      isAudioAnalyzing,
      isApplyingAudioDescription,
      pendingAudioDescription,
      // Rights & Identifiers fields
      isrc,
      iswc,
      recordLabel,
      publisher,
      flightingCode,
      assignedUid,
      // eslint-disable-next-line no-unused-vars
      singleTrackId,
      // Approval pipeline fields
      approval_status,
    } = this.state;

    // Prepare current metadata for the chatbot
    const currentMetadata = {
      uploadMode,
      trackName: trackName || '',
      tags: Array.isArray(tags) ? tags.map(t => t.label || t.name || t.value) : [],
      jobTitle: jobTitle || '',
      producer: producer && (producer.label || producer.name || producer.value) ? (producer.label || producer.name || producer.value) : '',
      agency: agency && (agency.label || agency.name || agency.value) ? (agency.label || agency.name || agency.value) : '',
      client: client && (client.label || client.name || client.value) ? (client.label || client.name || client.value) : '',
      creativedirector: Array.isArray(creativedirector) ? creativedirector.map(cd => cd.label || cd.name || cd.value) : [],
      dateCompleted,
      dateExpires,
      flightingPlatform: Array.isArray(flightingPlatform) ? flightingPlatform.map(fp => fp.label || fp.name || fp.value) : [],
      genre: genre && (genre.label || genre.name || genre.value) ? (genre.label || genre.name || genre.value) : '',
      bpm: bpm && (bpm.label || bpm.name || bpm.value) ? (bpm.label || bpm.name || bpm.value) : '',
      key: key && (key.label || key.name || key.value) ? (key.label || key.name || key.value) : '',
      composer: Array.isArray(composer) ? composer.map(c => c.label || c.name || c.value) : [],
      studio: studio && (studio.label || studio.name || studio.value) ? (studio.label || studio.name || studio.value) : '',
      backupLocation: backupLocation && (backupLocation.label || backupLocation.name || backupLocation.value) ? (backupLocation.label || backupLocation.name || backupLocation.value) : '',
      sessionArtists: Array.isArray(sessionArtists) ? sessionArtists.map(sa => sa.label || sa.name || sa.value) : [],
      notes: notes || '',
    };

    //console.log('[AddAudioForm render] isEditMode:', isEditMode, 'singleTrackId:', singleTrackId);

    const hasUploadedFiles =
      (uploadMode === 'batch'
        ? this.state.pendingBatchTracks.some(
            t => t.wav && t.wav.downloadUrl
          )
        : (mp3Files.length > 0 || wavFiles.length > 0));


    const { classes } = this.props;
    const { presets, showPresets, presetLoading } = this.state;

    return (
      <Form>
        {/* Toast for save success */}
        {this.state.showSaveToast && (
          <div className="toast-container">
            <Alert color="success" isOpen className="alert-toast">
              <strong>Saved successfully!</strong>
            </Alert>
          </div>
        )}
        <Row>
          <Col>
            <header>
              <h2 className="text-uppercase">
                <i className="tim-icons icon-cloud-upload-94 accent-1-icon icon-medium mr-2"></i>{' '}
                Upload Audio Files
              </h2>
            </header>
            {/* Approval status badge - shown in edit mode */}
            {isEditMode && approval_status && approval_status !== 'n/a' && (
              <div style={{ marginBottom: '1rem' }}>
                <span style={{
                  display: 'inline-block',
                  padding: '4px 12px',
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  fontWeight: '500',
                  backgroundColor:
                    approval_status === 'approved' ? 'rgba(80, 200, 120, 0.2)' :
                    approval_status === 'rejected' ? 'rgba(255, 80, 80, 0.2)' :
                    approval_status === 'pending' ? 'rgba(255, 180, 50, 0.2)' :
                    'rgba(255, 255, 255, 0.1)',
                  color:
                    approval_status === 'approved' ? '#50c878' :
                    approval_status === 'rejected' ? '#ff5050' :
                    approval_status === 'pending' ? '#ffb432' :
                    'rgba(255, 255, 255, 0.5)',
                }}>
                  {approval_status === 'approved' && this.state.qc_status !== 'fail' && 'Approved'}
                  {approval_status === 'approved' && this.state.qc_status === 'fail' && 'Approved — QC failed, upload corrected mix'}
                  {approval_status === 'rejected' && 'Rejected — upload updated files and save to resubmit'}
                  {approval_status === 'pending' && 'Pending Approval'}
                  {approval_status === 'unshared' && this.state.qc_status === 'fail' && 'QC failed — upload corrected mix'}
                  {approval_status === 'unshared' && this.state.qc_status !== 'fail' && 'Not yet shared for review'}
                </span>
                {approval_status === 'pending' && (
                  <Button
                    size="sm"
                    className="btn-danger-custom ml-3"
                    onClick={this.handleRecallReview}
                    style={{ fontSize: '0.8rem', padding: '3px 12px' }}
                  >
                    <span style={{ position: 'relative', zIndex: 2 }}>Recall</span>
                  </Button>
                )}
              </div>
            )}
            
            {/* Upload control based on approval + QC status */}
            {(() => {
              const qcStatus = this.state.qc_status;
              const canShowUploader = !isEditMode || (
                this.state.singleTrackId && (
                  !approval_status ||
                  approval_status === 'unshared' ||
                  approval_status === 'rejected' ||
                  (approval_status === 'approved' && qcStatus !== 'pass') // Allow until QC passes
                )
              );
              const isBlocked = isEditMode && (
                approval_status === 'pending' ||
                (approval_status === 'approved' && qcStatus === 'pass') // Only block when QC passed
              );

              return (
                <>
                  {canShowUploader && (
                    <MultiFileUploader
                      key={this.state.uploaderKey}
                      onUploadSuccess={this.handleBatchUploadSuccess}
                      toggleFileSelected={this.toggleFileSelected}
                      documentRef={this.audioMetaRef}
                      id="multiInput"
                      onStatusChange={this.handleUploaderStatus}
                      onModeChange={this.handleUploadModeChange}
                      batchTracks={this.state.pendingBatchTracks}
                      onBatchFilesSelected={this.handleBatchFilesSelected}
                      singleTrackId={this.state.singleTrackId}
                      onSingleFilesSelected={this.handleSingleFilesSelected}
                      isEditMode={isEditMode}
                      onSingleTrackNameEdit={this.handleSingleTrackNameEdit}
                      onApplyTrackNameToFirstPair={this.setUploaderFirstPairNameSetter}
                      onApplyTrackNameToBatchPair={this.setUploaderBatchNameSetter}
                      canonicalTrackName={this.state.trackName}
                      autoAnalyzeAudio={autoAnalyzeAudio}
                      onAudioAnalysis={this.handleAudioAnalysis}
                      fileVersion={this.state.fileVersion || 1}
                      qcVersion={this.state.qcVersion || 1}
                      uploadDisabled={false}
                      uploadDisabledMessage={isEditMode && (mp3Files.length > 0 || wavFiles.length > 0)
                        ? 'Drag and drop .wav and .mp3 files here, or click to select. Uploading new files will replace the existing files.'
                        : undefined
                      }
                    />
                  )}
                  {isBlocked && (
                    <div style={{
                      padding: '1rem',
                      backgroundColor: approval_status === 'approved' ? 'rgba(80, 200, 120, 0.1)' : 'rgba(255, 180, 50, 0.1)',
                      borderRadius: '8px',
                      border: `1px solid ${approval_status === 'approved' ? 'rgba(80, 200, 120, 0.3)' : 'rgba(255, 180, 50, 0.3)'}`,
                      color: approval_status === 'approved' ? '#50c878' : '#ffb432',
                      fontSize: '0.9rem',
                      marginBottom: '1rem',
                    }}>
                      {approval_status === 'approved' && qcStatus === 'pass'
                        ? 'This spot has been approved and passed QC. File uploads are locked.'
                        : approval_status === 'approved'
                          ? 'This spot has been approved. Run QC to proceed.'
                          : 'This spot is pending approval. Recall the review to make changes.'
                      }
                    </div>
                  )}
                </>
              );
            })()}
            {(mp3Files.length > 0 || wavFiles.length > 0) && (
              <Card className="no-bg-card mb-3">
                <CardBody>
                  <h5>Uploaded Files</h5>
                  {mp3Files.length > 0 && (
                    <div className="mb-2">
                      <AudioFileList
                        files={mp3Files.map(f => ({
                          ...f,
                          fileName: (f.fileName || '').replace(/\.mp3$/i, ''),
                        }))}
                        deleteFileHandler={(filePath, idx) => {
                          // Delete the MP3
                          this.handleDeleteFile(filePath, idx, 'mp3Files');
                          // Also delete the matching WAV (same version)
                          const mp3File = mp3Files[idx];
                          if (mp3File) {
                            const matchingWavIdx = wavFiles.findIndex(w =>
                              w.version === mp3File.version &&
                              (!mp3File.qcVersion || w.qcVersion === mp3File.qcVersion)
                            );
                            if (matchingWavIdx >= 0) {
                              this.handleDeleteFile(wavFiles[matchingWavIdx].storageRef, matchingWavIdx, 'wavFiles');
                            }
                          }
                        }}
                        group="mp3Files"
                        id="mp3FilesList"
                        showRadio={mp3Files.length > 1}
                        selectedMp3Id={selectedMp3Id}
                        onSelectMp3Id={(id) => this.setState({ selectedMp3Id: id })}
                        approvalStatus={this.state.approval_status}
                        qcStatus={this.state.qc_status}
                        currentQcVersion={this.state.qcVersion || 1}
                        currentFileVersion={this.state.fileVersion || 1}
                      />
                    </div>
                  )}
                  {mp3Files.length === 0 && wavFiles.length > 0 && (
                    <div className="mb-2">
                      <AudioFileList
                        files={wavFiles.map(f => ({
                          ...f,
                          fileName: (f.fileName || '').replace(/\.wav$/i, ''),
                        }))}
                        deleteFileHandler={(filePath, idx) => this.handleDeleteFile(filePath, idx, 'wavFiles')}
                        group="wavFiles"
                        id="wavFilesList"
                        approvalStatus={this.state.approval_status}
                        qcStatus={this.state.qc_status}
                        currentQcVersion={this.state.qcVersion || 1}
                        currentFileVersion={this.state.fileVersion || 1}
                      />
                    </div>
                  )}
                  {mp3Files.length === 0 && wavFiles.length === 0 && (
                    <div className="text-muted">No files uploaded yet.</div>
                  )}
                </CardBody>
              </Card>
            )}
            {false && (
              <Card className="no-bg-card">
                <CardBody>
                  <FormGroup>
                    <h3 className="mb-0">Color</h3>
                    <hr className="line-info" />
                    {/* <CirclePicker
                      color={trackColor}
                      onChange={this.handleColorChange}
                    /> */}
                  </FormGroup>
                </CardBody>
              </Card>
            )}
            {/* Rating card - commented out for Spot Management MVP */}
            {/*
            <Card className="no-bg-card">
              <CardBody>
                <FormGroup>
                  <h3 className="mb-0">Rating</h3>
                  <hr className="line-info" />
                  <StarRatingComponent
                    name="trackRating"
                    onStarClick={this.handleRatingChange}
                    renderStarIcon={() => (
                      <i className="tim-icons icon-shape-star" style={{ fontSize: '24px' }}></i>
                    )}
                    starCount={5}
                    value={trackRating}
                  />
                </FormGroup>
              </CardBody>
            </Card>
            */}
          </Col>
          <Col>
            <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <h2 className="text-uppercase">
                <i className="tim-icons icon-notes accent-1-icon icon-medium mr-2"></i>{' '}
                Meta Data
              </h2>
              <div style={{ marginLeft: 'auto', position: 'relative', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <button
                  type="button"
                  className="btn-secondary-custom btn-ripple"
                  style={{
                    cursor: 'pointer',
                    height: 35,
                    padding: '0 12px',
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={this.toggleAllCards}
                  title={this.areAllCardsExpanded() ? 'Collapse all sections' : 'Expand all sections'}
                >
                  <i className={`tim-icons ${this.areAllCardsExpanded() ? 'icon-minimal-up' : 'icon-minimal-down'}`} style={{ marginRight: 6, fontSize: 12 }}></i>
                  <span style={{ fontWeight: 400 }}>{this.areAllCardsExpanded() ? 'Collapse All' : 'Expand All'}</span>
                </button>
                <div style={{ width: 100, height: 35, display: 'flex', alignItems: 'stretch' }}>
                  <button
                    type="button"
                    className="btn-danger-custom btn-ripple"
                    style={{
                      cursor: 'pointer',
                      width: '100%',
                      height: '100%',
                      margin: 0,
                      padding: 0,
                      alignSelf: 'stretch',
                      borderRadius: 6,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onClick={() => this.setState({ showPresets: !showPresets })}
                  >
                    <span style={{ fontWeight: 400 }}>Presets</span>
                  </button>
                </div>
                {showPresets && (
                  <div className="popover presets-popover" style={{ 
                    position: 'absolute', 
                    right: 0, 
                    top: '100%', 
                    zIndex: 100, 
                    minWidth: 200, 
                    marginTop: 8, 
                    display: 'block'
                  }}>
                    <div className="popover-body">
                    <button
                      type="button"
                      className="popover-action"
                      onClick={this.handleSavePreset}
                      disabled={presetLoading}
                      style={{ 
                        marginTop: 6
                      }}
                    >
                      <span style={{ fontWeight: 'bold' }}>+ Save Preset</span>
                    </button>
                    {presetLoading && <div style={{ color: '#fff', fontSize: 10, marginBottom: 0 }}>Loading...</div>}
                    {presets.length === 0 && !presetLoading && <div style={{ color: '#bbb', fontSize: 12 }}>No presets saved.</div>}
                    {presets.map(preset => (
                      <div key={preset.id} style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                        <button
                          type="button"
                          className="popover-action"
                          onClick={() => this.handleApplyPreset(preset.metadata)}
                          style={{ 
                            flex: 1,
                            marginRight: 6,
                            justifyContent: 'flex-start'
                          }}
                        >
                          <span style={{ 
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>{preset.name}</span>
                        </button>
                        <button 
                          type="button"
                          onClick={() => this.handleDeletePreset(preset.id)} 
                          aria-label="Delete preset" 
                          style={{ 
                            color: '#000000', 
                            fontSize: 12, 
                            padding: '4px 8px 4px 4px',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'color var(--transition-fast)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onMouseEnter={(e) => e.target.style.color = 'var(--accent-1-color)'}
                          onMouseLeave={(e) => e.target.style.color = '#000000'}
                        >
                          <i className="tim-icons icon-trash-simple"></i>
                        </button>
                      </div>
                    ))}
                    </div>
                  </div>
                )}
              </div>
            </header>
            <Card className="no-bg-card">
              <CardBody>
                {/* Spot Details Section - Collapsible */}
                <CollapsibleCard
                  title="Spot Details"
                  expanded={this.state.cardExpanded.trackInfo}
                  onToggle={(expanded) => this.handleCardToggle('trackInfo', expanded)}
                >
                {/* Auto-analyze and Public controls - commented out for Spot Management MVP
                  headerContent={
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={autoAnalyzeAudio}
                        onChange={this.handleAutoAnalyzeToggle}
                        size="small"
                        icon={<CheckBoxOutlineBlankIcon style={{ color: 'rgba(255,255,255,0.5)', fontSize: 20 }} />}
                        checkedIcon={<CheckBoxIcon style={{ color: '#fff', fontSize: 20 }} />}
                        inputProps={{ title: "Auto-analyze uploaded audio files" }}
                        style={{ padding: '4px', marginRight: '8px' }}
                      />
                      <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem', marginRight: '16px' }}>
                        Auto-analyze
                      </span>
                      <Checkbox
                        checked={this.state.isPublic}
                        onChange={this.handlePublicToggle}
                        size="small"
                        icon={<CheckBoxOutlineBlankIcon style={{ color: 'rgba(255,255,255,0.5)', fontSize: 20 }} />}
                        checkedIcon={<CheckBoxIcon style={{ color: 'var(--accent-1-color)', fontSize: 20 }} />}
                        inputProps={{ title: "Add to public catalogue for other users to discover" }}
                        style={{ padding: '4px', marginRight: '8px' }}
                      />
                      <span style={{ color: this.state.isPublic ? 'var(--accent-1-color)' : 'rgba(255,255,255,0.8)', fontSize: '0.875rem', marginRight: '16px' }}>
                        Public
                      </span>
                      {(isAudioAnalyzing || isApplyingAudioDescription) && (
                        <span className="ml-2">
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ color: 'var(--accent-1-color)' }}></span>
                        </span>
                      )}
                      {pendingAudioDescription && !isAudioAnalyzing && !isApplyingAudioDescription && (
                        <button
                          type="button"
                          className="ml-2"
                          style={{
                            backgroundColor: 'transparent',
                            color: 'var(--accent-1-color)',
                            border: '1px solid var(--accent-1-color)',
                            padding: '4px 12px',
                            fontSize: '12px',
                            fontWeight: 400,
                            cursor: 'pointer',
                            borderRadius: 6,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onClick={this.handleApplyAudioDescription}
                        >
                          Apply
                        </button>
                      )}
                    </div>
                  }
                */}
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Spot Name - Flighting Code</Label>
                      <Autocomplete
                        freeSolo
                        options={this.state.availableTrackNames || []}
                        getOptionLabel={option => typeof option === 'string' ? option : (option.label || option.name || '')}
                        value={this.state.uploadMode === 'batch' ? 'Batch Mode' : (trackName || '')}
                        onChange={(event, newValue) => {
                          const name = typeof newValue === 'string' ? newValue : (newValue && (newValue.label || newValue.name));
                          // Normalise separators silently — user sees the canonical
                          // form (underscores only) appear in the field as they type.
                          this.setState({ trackName: normaliseFlightingCode(name) });
                        }}
                        onInputChange={(event, newInputValue) => {
                          const normalisedInput = normaliseFlightingCode(newInputValue);
                          this.setState({ trackName: normalisedInput }, () => {
                            // Schedule sync for next tick, after state is updated
                            if (
                              this.state.uploadMode === 'single' &&
                              this.uploaderFirstPairNameSetter &&
                              !this.syncingTrackName
                            ) {
                              this.syncingTrackName = true;
                              setTimeout(() => {
                                this.uploaderFirstPairNameSetter(this.state.trackName);
                                this.syncingTrackName = false;
                              }, 0);
                            }
                          });
                        }}
                        disabled={this.state.uploadMode === 'batch'}
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder={this.state.uploadMode === 'batch' ? 'Batch Mode' : 'Enter spot name - flighting code'}
                            className={classes.autocomplete}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'on',
                              name: 'trackName',
                              style: this.state.uploadMode === 'batch' ? { color: 'var(--accent-1-color)', fontWeight: 600 } : params.inputProps.style,
                            }}
                          />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {typeof option === 'string' ? option : (option.label || option.name)}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Language</Label>
                      <Autocomplete
                        multiple
                        options={LANGUAGE_OPTIONS}
                        getOptionLabel={option => option.label || ''}
                        value={language || []}
                        onChange={(event, newValue) => {
                          this.setState({ language: newValue });
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip key={option.value} label={option.label} {...getTagProps({ index })} className="custom-chip" />
                          ))
                        }
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder="Select languages" className={classes.autocomplete} />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* Artist, Album, Genre fields - commented out for Spot Management MVP */}
                {/*
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Artist</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'artist')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={artist || null}
                        options={this.state.availableArtists || []}
                        inputValue={this.state.artistInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ artistInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ artistInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'artists', 'artist', false, this.showModalRef);
                              this.setState({ artist: created, artistInputValue: '' });
                            }
                          } else {
                            this.setState({ artist: newValue, artistInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = artist;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select artist"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>Album</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'album')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={album || null}
                        options={this.state.availableAlbums || []}
                        inputValue={this.state.albumInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ albumInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ albumInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'albums', 'album', false, this.showModalRef);
                              this.setState({ album: created, albumInputValue: '' });
                            }
                          } else {
                            this.setState({ album: newValue, albumInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = album;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select album"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Genre</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'genre')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={genre || null}
                        options={this.state.availableGenres || []}
                        inputValue={this.state.genreInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ genreInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ genreInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'genres', 'genre', false, this.showModalRef);
                              this.setState({ genre: created, genreInputValue: '' });
                            }
                          } else {
                            this.setState({ genre: newValue, genreInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = genre;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select genre"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                */}
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Tags</Label>
                      <CategorizedAutocomplete
                        multiple
                        freeSolo
                        options={availableTags || []}
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'tags')}
                        getOptionLabel={option =>
                          option.isCreate ? option.label : (option.name || option.label || option.value || option.id || (typeof option === 'string' ? option : ''))
                        }
                        value={tags || []}
                        onChange={async (event, newValue, reason) => {
                          const last = newValue[newValue.length - 1];
                          if (last && last.isCreate) {
                            if (this.showModalRef) {
                              const createdTag = await this.createAndSelectOption(last.inputValue, 'tags', 'tags', true, this.showModalRef);
                              this.setState({ tags: [...newValue.slice(0, -1), createdTag] });
                            }
                          } else {
                            this.setState({ tags: newValue });
                          }
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder="Select tags" className={classes.autocomplete} />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        section="tags"
                        showActionButtons={false}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* Key and BPM fields - commented out for Spot Management MVP */}
                {/*
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label>Key</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'key')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={key || null}
                        options={this.state.availableKeys || []}
                        inputValue={this.state.keyInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ keyInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ keyInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'keys', 'key', false, this.showModalRef);
                              this.setState({ key: created, keyInputValue: '' });
                            }
                          } else {
                            this.setState({ key: newValue, keyInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = key;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select key"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>Bpm</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'bpm')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={bpm || null}
                        options={this.state.availableBpms || []}
                        inputValue={this.state.bpmInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ bpmInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ bpmInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'bpm', 'bpm', false, this.showModalRef);
                              this.setState({ bpm: created, bpmInputValue: '' });
                            }
                          } else {
                            this.setState({ bpm: newValue, bpmInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = bpm;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select bpm"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                */}
                </CollapsibleCard>
              </CardBody>
            </Card>
            <Card className="no-bg-card">
              <CardBody>
                {/* Project Section - Collapsible */}
                <CollapsibleCard title="Project" expanded={this.state.cardExpanded.job} onToggle={(expanded) => this.handleCardToggle('job', expanded)}>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Campaign</Label>
                      <Autocomplete
                        freeSolo
                        options={this.state.availableJobTitles || []}
                        getOptionLabel={option => typeof option === 'string' ? option : (option.label || option.name || '')}
                        value={jobTitle || ''}
                        onChange={(event, newValue) => this.setState({ jobTitle: typeof newValue === 'string' ? newValue : (newValue && (newValue.label || newValue.name)) })}
                        onInputChange={(event, newInputValue) => this.setState({ jobTitle: newInputValue })}
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Enter or select job title"
                            className={classes.autocomplete}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'on',
                              name: 'jobTitle',
                            }}
                          />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {typeof option === 'string' ? option : (option.label || option.name)}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Client</Label>
                      <Autocomplete
                        freeSolo
                        options={availableClients || []}
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'client')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={client || null}
                        inputValue={this.state.clientInputValue}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ clientInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ clientInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            // Use ModalConsumer to get showModal
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'client', 'client', false, this.showModalRef);
                              this.setState({ client: created, clientInputValue: '' });
                            }
                          } else {
                            this.setState({ client: newValue, clientInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = client;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select client"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>Agency</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'agency')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={agency || null}
                        options={this.state.availableAgencies || []}
                        inputValue={this.state.agencyInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ agencyInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ agencyInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'agency', 'agency', false, this.showModalRef);
                              this.setState({ agency: created, agencyInputValue: '' });
                            }
                          } else {
                            this.setState({ agency: newValue, agencyInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = agency;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select agency"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Producer</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'producer')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={producer || null}
                        options={this.state.availableProducers || []}
                        inputValue={this.state.producerInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ producerInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ producerInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'producer', 'producer', false, this.showModalRef);
                              this.setState({ producer: created, producerInputValue: '' });
                            }
                          } else {
                            this.setState({ producer: newValue, producerInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = producer;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select producer"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>Creative Directors</Label>
                      <Autocomplete
                        multiple
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'creativedirector')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.name || option.label)}
                        value={creativedirector || []}
                        options={this.state.availableCreativeDirectors || []}
                        inputValue={this.state.creativeDirectorInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ creativeDirectorInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ creativeDirectorInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          const last = newValue[newValue.length - 1];
                          if (last && last.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(last.inputValue, 'creativedirector', 'creativedirector', true, this.showModalRef);
                              this.setState({ creativedirector: [...newValue.slice(0, -1), created], creativeDirectorInputValue: '' });
                            }
                          } else {
                            this.setState({ creativedirector: newValue, creativeDirectorInputValue: '' });
                          }
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip key={option.id} label={option.name || option.label} {...getTagProps({ index })} className="custom-chip" />
                          ))
                        }
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder="Select creative directors" className={classes.autocomplete} />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.name || option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* Studio field - moved here from Composer Details for Spot Management MVP */}
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Studio</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'studio')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={studio || null}
                        options={this.state.availableStudios || []}
                        inputValue={this.state.studioInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ studioInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ studioInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'studio', 'studio', false, this.showModalRef);
                              this.setState({ studio: created, studioInputValue: '' });
                            }
                          } else {
                            this.setState({ studio: newValue, studioInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = studio;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select studio"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* Flighting Platform - commented out for Spot Management MVP */}
                {/*
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Flighting Platform</Label>
                      <Autocomplete
                        multiple
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'flightingPlatform')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.name || option.label)}
                        value={flightingPlatform || []}
                        options={this.state.availableFlightingPlatforms || []}
                        inputValue={this.state.flightingPlatformInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ flightingPlatformInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ flightingPlatformInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          const last = newValue[newValue.length - 1];
                          if (last && last.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(last.inputValue, 'flightingplatform', 'flightingPlatform', true, this.showModalRef);
                              this.setState({ flightingPlatform: [...newValue.slice(0, -1), created], flightingPlatformInputValue: '' });
                            }
                          } else {
                            this.setState({ flightingPlatform: newValue, flightingPlatformInputValue: '' });
                          }
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip key={option.id} label={option.name || option.label} {...getTagProps({ index })} className="custom-chip" />
                          ))
                        }
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder="Select flighting platforms" className={classes.autocomplete} />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.name || option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                */}
                </CollapsibleCard>
              </CardBody>
            </Card>
            <Card className="no-bg-card">
              <CardBody>
                {/* Date Section - Collapsible */}
                <CollapsibleCard title="Date" expanded={this.state.cardExpanded.date} onToggle={(expanded) => this.handleCardToggle('date', expanded)}>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label>Date Completed</Label>
                        <TextField
                          variant="outlined"
                          type="date"
                          value={
                            typeof dateCompleted === 'number'
                              ? new Date(dateCompleted).toISOString().slice(0, 10)
                              : (typeof dateCompleted === 'string' && dateCompleted.match(/^\d{4}-\d{2}-\d{2}$/))
                                ? dateCompleted
                                : ''
                          }
                          onChange={e => {
                            const val = e.target.value;
                            this.setState({ dateCompleted: val ? new Date(val).getTime() : '' });
                          }}
                          className={classes.autocomplete}
                          style={{ width: '100%' }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label>Date Expires</Label>
                        <TextField
                          variant="outlined"
                          type="date"
                          value={
                            typeof dateExpires === 'number'
                              ? new Date(dateExpires).toISOString().slice(0, 10)
                              : (typeof dateExpires === 'string' && dateExpires.match(/^\d{4}-\d{2}-\d{2}$/))
                                ? dateExpires
                                : ''
                          }
                          onChange={e => {
                            const val = e.target.value;
                            this.setState({ dateExpires: val ? new Date(val).getTime() : '' });
                          }}
                          className={classes.autocomplete}
                          style={{ width: '100%' }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CollapsibleCard>
              </CardBody>
            </Card>
            {/* Composer Details card - commented out for Spot Management MVP (Studio moved to Project card) */}
            {/*
            <Card className="no-bg-card">
              <CardBody>
                <CollapsibleCard title="Composer Details" expanded={this.state.cardExpanded.composerDetails} onToggle={(expanded) => this.handleCardToggle('composerDetails', expanded)}>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Composers</Label>
                      <Autocomplete
                        multiple
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'composer')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.name || option.label || option.value || option.id || (typeof option === 'string' ? option : ''))}
                        value={composer || []}
                        options={this.state.availableComposers || []}
                        inputValue={this.state.composerInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ composerInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ composerInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          const last = newValue[newValue.length - 1];
                          if (last && last.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(last.inputValue, 'composers', 'composer', true, this.showModalRef);
                              this.setState({ composer: [...newValue.slice(0, -1), created], composerInputValue: '' });
                            }
                          } else {
                            // Preserve existing split values when composers change
                            const existingComposers = this.state.composer || [];
                            const mergedValue = newValue.map(newComp => {
                              // Find matching existing composer to preserve split
                              const existing = existingComposers.find(ec =>
                                (ec.id && ec.id === newComp.id) ||
                                (ec.value && ec.value === newComp.value) ||
                                (ec.label && ec.label === newComp.label)
                              );
                              if (existing && existing.split !== undefined) {
                                return { ...newComp, split: existing.split };
                              }
                              return newComp;
                            });
                            this.setState({ composer: mergedValue, composerInputValue: '' });
                          }
                        }}
                        renderTags={(value, getTagProps) => {
                          // Calculate remaining percentage and count of composers without splits
                          const manualSplitsTotal = value.reduce((sum, c) => {
                            return sum + (c.split !== undefined && c.split !== '' ? Number(c.split) : 0);
                          }, 0);
                          const composersWithoutSplitList = value.filter(c => c.split === undefined || c.split === '');
                          const composersWithoutSplitCount = composersWithoutSplitList.length;
                          const remainingPercent = Math.max(0, 100 - manualSplitsTotal);

                          // Calculate base split and last composer adjustment (single decimal precision)
                          const baseSplit = composersWithoutSplitCount > 0
                            ? Math.floor((remainingPercent / composersWithoutSplitCount) * 10) / 10
                            : 0;
                          const totalFromBaseSplits = baseSplit * (composersWithoutSplitCount - 1);
                          const lastComposerSplit = composersWithoutSplitCount > 0
                            ? Math.round((remainingPercent - totalFromBaseSplits) * 10) / 10
                            : 0;

                          // Track position among composers without splits
                          let autoSplitIndex = 0;

                          return value.map((option, index) => {
                            const hasManualSplit = option.split !== undefined && option.split !== '';
                            let placeholderValue = baseSplit;

                            if (!hasManualSplit) {
                              autoSplitIndex++;
                              // Last auto-split composer gets the adjusted value
                              if (autoSplitIndex === composersWithoutSplitCount) {
                                placeholderValue = lastComposerSplit;
                              }
                            }

                            return (
                              <ComposerChip
                                key={option.id || index}
                                composer={option}
                                index={index}
                                getTagProps={getTagProps}
                                onSplitChange={this.handleComposerSplitChange}
                                placeholderValue={placeholderValue}
                              />
                            );
                          });
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder="Select composers" className={classes.autocomplete} />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.name || option.label || option.value || option.id || (typeof option === 'string' ? option : '')}
                          </div>
                        )}
                      />
                      {/* Composer splits validation message - only show warning if splits don't equal 100% * /}
                      {composer && composer.length > 1 && this.getComposerSplitsTotal() !== 100 && (
                        <div className="composer-splits-warning">
                          <span className="warning-icon">⚠</span>
                          <span>Splits total {this.getComposerSplitsTotal()}% (should be 100%)</span>
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Studio</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'studio')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={studio || null}
                        options={this.state.availableStudios || []}
                        inputValue={this.state.studioInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ studioInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ studioInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'studio', 'studio', false, this.showModalRef);
                              this.setState({ studio: created, studioInputValue: '' });
                            }
                          } else {
                            this.setState({ studio: newValue, studioInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = studio;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select studio"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Session Artists</Label>
                      <Autocomplete
                        multiple
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'sessionArtists')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.name || option.label || option.value || option.id || (typeof option === 'string' ? option : ''))}
                        value={sessionArtists || []}
                        options={this.state.availableSessionArtists || []}
                        inputValue={this.state.sessionArtistsInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ sessionArtistsInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ sessionArtistsInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          const last = newValue[newValue.length - 1];
                          if (last && last.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(last.inputValue, 'sessionartists', 'sessionArtists', true, this.showModalRef);
                              this.setState({ sessionArtists: [...newValue.slice(0, -1), created], sessionArtistsInputValue: '' });
                            }
                          } else {
                            this.setState({ sessionArtists: newValue, sessionArtistsInputValue: '' });
                          }
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip key={option.id} label={option.name || option.label || option.value || option.id || (typeof option === 'string' ? option : '')} {...getTagProps({ index })} className="custom-chip" />
                          ))
                        }
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder="Select session artists" className={classes.autocomplete} />
                        )}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.name || option.label || option.value || option.id || (typeof option === 'string' ? option : '')}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                </CollapsibleCard>
              </CardBody>
            </Card>
            */}
            {/* Rights & Identifiers card - commented out for Spot Management MVP */}
            {/*
            <Card className="no-bg-card">
              <CardBody>
                <CollapsibleCard title="Rights & Identifiers" expanded={this.state.cardExpanded.rightsIdentifiers} onToggle={(expanded) => this.handleCardToggle('rightsIdentifiers', expanded)}>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>ISRC Number</Label>
                      <TextField
                        variant="outlined"
                        value={isrc || ''}
                        onChange={e => this.setState({ isrc: e.target.value })}
                        placeholder="e.g., ZA-XXX-24-00001"
                        className={classes.autocomplete}
                        style={{ width: '100%' }}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>ISWC Number</Label>
                      <TextField
                        variant="outlined"
                        value={iswc || ''}
                        onChange={e => this.setState({ iswc: e.target.value })}
                        placeholder="e.g., T-123456789-0"
                        className={classes.autocomplete}
                        style={{ width: '100%' }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Record Label</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'recordLabel')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={recordLabel || null}
                        options={this.state.availableRecordLabels || []}
                        inputValue={this.state.recordLabelInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ recordLabelInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ recordLabelInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'recordlabels', 'recordLabel', false, this.showModalRef);
                              this.setState({ recordLabel: created, recordLabelInputValue: '' });
                            }
                          } else {
                            this.setState({ recordLabel: newValue, recordLabelInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = recordLabel;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select record label"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>Publisher</Label>
                      <Autocomplete
                        freeSolo
                        filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'publisher')}
                        getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                        value={publisher || null}
                        options={this.state.availablePublishers || []}
                        inputValue={this.state.publisherInputValue || ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason !== 'reset') {
                            this.setState({ publisherInputValue: newInputValue });
                          }
                        }}
                        onBlur={() => this.setState({ publisherInputValue: '' })}
                        onChange={async (event, newValue, reason) => {
                          if (newValue && newValue.isCreate) {
                            if (this.showModalRef) {
                              const created = await this.createAndSelectOption(newValue.inputValue, 'publishers', 'publisher', false, this.showModalRef);
                              this.setState({ publisher: created, publisherInputValue: '' });
                            }
                          } else {
                            this.setState({ publisher: newValue, publisherInputValue: '' });
                          }
                        }}
                        renderInput={params => {
                          const selected = publisher;
                          return (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select publisher"
                              className={classes.autocomplete}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: renderSelectedValue(selected),
                              }}
                              inputProps={{
                                ...params.inputProps,
                                style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                              }}
                            />
                          );
                        }}
                        className={classes.autocomplete}
                        autoHighlight
                        renderOption={(option, { selected }) => (
                          <div style={{
                            backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                            color: selected ? '#fff' : undefined,
                            borderRadius: selected ? '8px' : undefined,
                            padding: selected ? '4px 16px' : '4px 16px',
                            margin: selected ? '2px 0' : '0',
                            display: 'inline-block',
                            minWidth: '80%',
                            fontSize: 'var(--menu-font-size)',
                            fontFamily: 'var(--font-family-primary)',
                            transition: 'background 0.15s, color 0.15s'
                          }}>
                            {option.label}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Flighting Code</Label>
                      <TextField
                        variant="outlined"
                        value={flightingCode || ''}
                        onChange={e => this.setState({ flightingCode: e.target.value })}
                        placeholder="Enter flighting code"
                        className={classes.autocomplete}
                        style={{ width: '100%' }}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>Assigned UID</Label>
                      <TextField
                        variant="outlined"
                        value={assignedUid || this.state.singleTrackId || this.props.trackId || ''}
                        className={classes.autocomplete}
                        style={{ width: '100%' }}
                        InputProps={{
                          readOnly: true,
                        }}
                        placeholder="Auto-generated on save"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                </CollapsibleCard>
              </CardBody>
            </Card>
            */}
            {/* Backup Location card - commented out for Spot Management MVP */}
            {/*
            <Card className="no-bg-card">
              <CardBody>
                <CollapsibleCard title="Backup Location" expanded={this.state.cardExpanded.backupLocation} onToggle={(expanded) => this.handleCardToggle('backupLocation', expanded)}>
                  <FormGroup>
                    <Autocomplete
                      freeSolo
                      filterOptions={(options, params) => makeCreatableFilterOptions(options, params, 'backupLocation')}
                      getOptionLabel={option => option.isCreate ? option.label : (option.label || '')}
                      value={backupLocation || null}
                      options={this.state.availableBackupLocations || []}
                      inputValue={this.state.backupLocationInputValue || ''}
                      onInputChange={(event, newInputValue, reason) => {
                        if (reason !== 'reset') {
                          this.setState({ backupLocationInputValue: newInputValue });
                        }
                      }}
                      onBlur={() => this.setState({ backupLocationInputValue: '' })}
                      onChange={async (event, newValue, reason) => {
                        if (newValue && newValue.isCreate) {
                          if (this.showModalRef) {
                            const created = await this.createAndSelectOption(newValue.inputValue, 'backuplocation', 'backupLocation', false, this.showModalRef);
                            this.setState({ backupLocation: created, backupLocationInputValue: '' });
                          }
                        } else {
                          this.setState({ backupLocation: newValue, backupLocationInputValue: '' });
                        }
                      }}
                      renderInput={params => {
                        const selected = backupLocation;
                        return (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Select backup location"
                            className={classes.autocomplete}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: renderSelectedValue(selected),
                            }}
                            inputProps={{
                              ...params.inputProps,
                              style: selected ? { color: 'transparent', textShadow: 'none' } : {},
                            }}
                          />
                        );
                      }}
                      className={classes.autocomplete}
                      autoHighlight
                      renderOption={(option, { selected }) => (
                        <div style={{
                          backgroundColor: selected ? 'var(--accent-1-color)' : 'transparent',
                          color: selected ? '#fff' : undefined,
                          borderRadius: selected ? '8px' : undefined,
                          padding: selected ? '4px 16px' : '4px 16px',
                          margin: selected ? '2px 0' : '0',
                          display: 'inline-block',
                          minWidth: '80%',
                          fontSize: 'var(--menu-font-size)',
                          fontFamily: 'var(--font-family-primary)',
                          transition: 'background 0.15s, color 0.15s'
                        }}>
                          {option.label}
                        </div>
                      )}
                    />
                  </FormGroup>
                </CollapsibleCard>
              </CardBody>
            </Card>
            */}
            <Card className="no-bg-card">
              <CardBody>
                {/* Notes Section - Collapsible */}
                <CollapsibleCard title="Notes" expanded={this.state.cardExpanded.notes} onToggle={(expanded) => this.handleCardToggle('notes', expanded)}>
                  <FormGroup>
                    <Input
                      onChange={this.handleChange}
                      value={notes}
                      name="notes"
                      type="textarea"
                    />
                  </FormGroup>
                </CollapsibleCard>
              </CardBody>
            </Card>
            {/* [CHATBOT-DISABLED 2026-09-30] Add-track Gemini chatbot hidden for
                now — forked from another project, still carries legacy UI +
                prompts. Code kept intact for a future revisit; un-comment to
                re-enable. (The ref stays null while disabled; callers already
                null-check it — see handleApplyMetadata / audio-analysis path.)
            {!isEditMode && (
              <Card className="no-bg-card mb-3">
                <CardBody>
                  <AddTrackChatbot
                    ref={this.addTrackChatbotRef}
                    onApplyMetadata={this.handleApplyMetadata}
                    currentMetadata={currentMetadata}
                    useSimplePrompts={false}
                    onApplyTrackNameToFirstPair={this.handleApplyTrackNameToFirstPair}
                    onApplyTrackNameToBatchPair={(name) => {
                      if (typeof this.uploaderBatchNameSetter === 'function') {
                        this.uploaderBatchNameSetter(name);
                        this.expandCardsWithValues(['trackName']);
                      } else {
                        console.warn('[AddTrackChatbot -> AddAudioForm] uploaderBatchNameSetter is not a function!');
                      }
                    }}
                    onAudioAnalysisStateChange={this.handleAudioAnalysisStateChange}
                    onAudioDescriptionReady={this.handleAudioDescriptionReady}
                  />
                </CardBody>
              </Card>
            )}
            */}
            <ModalConsumer>
              {({ showModal }) => {
                this.showModalRef = showModal;
                return (
                  <>
                    <Button
                      className="btn-round mt-4 btn-danger-custom"
                      size="lg"
                      disabled={this.uploading || this.hasQueuedFiles || !hasUploadedFiles}
                      onClick={(event) => {
                        if (this.selectedFiles.length > 0) {
                          showModal(ModalExample, {
                            isOpen: true,
                            title: 'Save Information',
                            body: `We have noticed that ${
                              this.selectedFiles.length === 1
                                ? 'one file has'
                                : this.selectedFiles.length + ' files have'
                            } not been uploaded. Would you like to proceed and save the information without including the selected file${
                              this.selectedFiles.length > 1 ? 's' : ''
                            }?`,
                            callback: () => {
                              this.onSubmit(event);
                            },
                          });
                        } else {
                          this.onSubmit(event);
                        }
                      }}
                    >
                      <span className="d-flex flex-row align-items-center">
                        <i className="tim-icons icon-simple-add mr-2"></i> Save
                        Information
                      </span>
                    </Button>
                  </>
                );
              }}
            </ModalConsumer>
          </Col>
        </Row>
        {this.state.showPresetNameModal && (
          <div className="modal-dialog" role="document" style={{ position: 'fixed', top: 100, left: '50%', transform: 'translateX(-50%)', zIndex: 2000, width: 400, maxWidth: '90vw' }}>
            <div className="modal-content delete-confirm-modal">
              <div className="modal-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--chatbot-color-2)' }}>
                <h5 className="modal-title" style={{ color: '#fff', fontWeight: 500, fontSize: 18, margin: 0 }}>Save Preset</h5>
                <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ showPresetNameModal: false, newPresetName: '' })} style={{ color: 'var(--accent-1-color)', opacity: 1, background: 'none', border: 'none', fontSize: '1.75rem', fontWeight: 'normal', padding: '0.25rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 'auto' }}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body" style={{ background: 'var(--chatbot-color-1)', color: '#fff', padding: '1.5rem', fontSize: 15 }}>
                <input
                  type="text"
                  value={this.state.newPresetName}
                  onChange={e => this.setState({ newPresetName: e.target.value })}
                  placeholder="Preset name"
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', fontSize: 15 }}
                  autoFocus
                />
              </div>
              <div className="modal-footer" style={{ background: 'var(--chatbot-color-2)', borderTop: '1px solid rgba(255,255,255,0.1)', padding: '1rem 1.5rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                <button
                  type="button"
                  className="ml-auto btn-warning-custom btn btn-secondary"
                  style={{ position: 'relative', zIndex: 2, minWidth: 90 }}
                  onClick={this.handleConfirmSavePreset}
                  disabled={!this.state.newPresetName.trim()}
                >
                  <span style={{ position: 'relative', zIndex: 3 }}>Save</span>
                </button>
                <button
                  type="button"
                  className="ml-2 btn-primary-custom btn btn-secondary"
                  style={{ position: 'relative', zIndex: 2, minWidth: 90 }}
                  onClick={() => this.setState({ showPresetNameModal: false, newPresetName: '' })}
                >
                  <span style={{ position: 'relative', zIndex: 3 }}>Cancel</span>
                </button>
              </div>
            </div>
          </div>
        )}

        {/* License Creation Prompt Modal */}
        {this.state.showLicensePromptModal && (
          <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog" role="document" style={{ maxWidth: 500, marginTop: '10vh' }}>
              <div className="modal-content delete-confirm-modal">
                <div className="modal-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--chatbot-color-2)' }}>
                  <h5 className="modal-title" style={{ color: '#fff', fontWeight: 500, fontSize: 18, margin: 0 }}>Create License?</h5>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={this.handleDeclineLicensePrompt}
                    style={{ color: 'var(--accent-1-color)', opacity: 1, background: 'none', border: 'none', fontSize: '1.75rem', fontWeight: 'normal', padding: '0.25rem', cursor: 'pointer' }}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body" style={{ background: 'var(--chatbot-color-1)', color: '#fff', padding: '1.5rem', fontSize: 15 }}>
                  <p style={{ marginBottom: '1rem' }}>
                    The expiry date you entered indicates this track is currently in license.
                  </p>
                  <p style={{ marginBottom: 0, color: 'rgba(255,255,255,0.7)' }}>
                    Would you like to create a license record for this track?
                  </p>
                </div>
                <div className="modal-footer" style={{ background: 'var(--chatbot-color-2)', borderTop: '1px solid rgba(255,255,255,0.1)', padding: '1rem 1.5rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                  <button
                    type="button"
                    className="btn-secondary-custom btn btn-secondary"
                    style={{ position: 'relative', zIndex: 2, minWidth: 90 }}
                    onClick={this.handleDeclineLicensePrompt}
                  >
                    <span style={{ position: 'relative', zIndex: 3 }}>No Thanks</span>
                  </button>
                  <button
                    type="button"
                    className="btn-primary-custom btn btn-secondary"
                    style={{ position: 'relative', zIndex: 2, minWidth: 90 }}
                    onClick={this.handleAcceptLicensePrompt}
                  >
                    <span style={{ position: 'relative', zIndex: 3 }}>Create License</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* License Creation Modal */}
        <ShareLicenseModal
          isOpen={this.state.showCreateLicenseModal}
          onClose={this.handleCloseLicenseModal}
          onApply={this.handleCreateLicense}
          trackName={this.state.pendingLicenseTrackData?.trackName || this.state.trackName || ''}
          trackData={this.state.pendingLicenseTrackData}
          firebase={this.props.firebase}
        />
      </Form>
    );
  }
}

/** Tiny HOC that pipes the global toast's `showSuccess` into the class
 *  component as a prop. Class components can't use the `useToast` hook
 *  directly; this is the minimal bridge. */
const withShowSuccess = (Inner) => {
  function WithShowSuccessWrapper(props) {
    const { showSuccess } = useToast();
    return <Inner {...props} showSuccess={showSuccess} />;
  }
  WithShowSuccessWrapper.displayName = `WithShowSuccess(${Inner.displayName || Inner.name || 'Component'})`;
  return WithShowSuccessWrapper;
};

export default withStyles(styles)(React.memo(withShowSuccess(AddAudioForm)));
